import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.sources');
import { OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";
import { formatKstDate, formatKstDateTime, serviceTimestamp } from "src/libs/portal/season/time";

@Component({
    selector: 'wiz-page-authoring-sources',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.sources/view.scss */
@charset "UTF-8";
:host {
  display: block;
}

.source-drive {
  position: relative;
  max-width: 1540px;
  min-height: 100vh;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 24px 28px 36px;
  color: #22312c;
}

button,
input,
select {
  font-family: inherit;
}

button,
label {
  -webkit-tap-highlight-color: transparent;
}

.drive-page-header {
  position: relative;
  z-index: 4;
  border-bottom: 1px solid #e7ecea;
  background: #fff;
}

.drive-navigation-bar {
  min-width: 0;
  min-height: 70px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 22px;
  border-bottom: 1px solid #edf1ef;
  gap: 22px;
}

.navigation-tools {
  min-width: 0;
  display: flex;
  flex: 0 1 650px;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.drive-search {
  min-width: 240px;
  max-width: 540px;
  height: 42px;
  display: flex;
  flex: 1 1 360px;
  align-items: center;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: #f1f4f3;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  gap: 11px;
}

.drive-search:focus-within {
  border-color: #c9d7d2;
  background: #fff;
  box-shadow: 0 2px 8px rgba(33, 58, 49, 0.09);
}

.drive-search > svg {
  width: 19px;
  height: 19px;
  flex: 0 0 auto;
  fill: none;
  stroke: #61736c;
  stroke-linecap: round;
  stroke-width: 1.8;
}

.drive-search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  color: #263b34;
  background: transparent;
  font-size: 13px;
}

.drive-search input::placeholder {
  color: #75857f;
}

.drive-search > button,
.close-button {
  width: 28px;
  height: 28px;
  display: grid;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-radius: 50%;
  place-items: center;
  color: #6e7d78;
  background: transparent;
  font-size: 18px;
}

.drive-search > button:hover,
.close-button:hover {
  background: #e7ecea;
}

.command-icon-button,
.selection-tool-button {
  width: 38px;
  height: 38px;
  display: grid;
  flex: 0 0 auto;
  box-sizing: border-box;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 10px;
  place-items: center;
  color: #50645c;
  background: transparent;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.command-icon-button:hover,
.selection-tool-button:hover {
  color: #126149;
  background: #e9f0ed;
}

.command-icon-button:focus-visible,
.selection-tool-button:focus-visible {
  outline: 2px solid #4b957b;
  outline-offset: 2px;
}

.command-icon-button[data-tooltip] {
  position: relative;
}

.command-icon-button[data-tooltip]::before,
.command-icon-button[data-tooltip]::after {
  position: absolute;
  left: 50%;
  z-index: 24;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transition: opacity 0.14s ease, transform 0.14s ease, visibility 0.14s ease;
  transition-delay: 0s;
}

.command-icon-button[data-tooltip]::before {
  content: "";
  bottom: calc(100% + 4px);
  border-width: 5px 5px 0;
  border-style: solid;
  border-color: #263b34 transparent transparent;
  transform: translate(-50%, 3px);
}

.command-icon-button[data-tooltip]::after {
  content: attr(data-tooltip);
  bottom: calc(100% + 9px);
  padding: 6px 8px;
  border-radius: 6px;
  color: #fff;
  background: #263b34;
  box-shadow: 0 4px 12px rgba(25, 48, 40, 0.18);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  transform: translate(-50%, 3px);
}

.command-icon-button[data-tooltip]:hover::before,
.command-icon-button[data-tooltip]:hover::after,
.command-icon-button[data-tooltip]:focus-visible::before,
.command-icon-button[data-tooltip]:focus-visible::after {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, 0);
  transition-delay: 0.25s;
}

.command-icon-button[data-tooltip][aria-expanded=true]::before,
.command-icon-button[data-tooltip][aria-expanded=true]::after {
  opacity: 0;
  visibility: hidden;
}

.command-icon-button:disabled,
.selection-tool-button:disabled {
  cursor: default;
  opacity: 0.38;
}

.command-icon-button svg,
.selection-tool-button svg {
  width: 19px;
  height: 19px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.organization-select {
  display: flex;
  align-items: center;
  color: #5f716a;
  font-size: 11px;
  font-weight: 700;
  gap: 7px;
}

.organization-select select {
  height: 36px;
  max-width: 180px;
  padding: 0 28px 0 10px;
  border: 1px solid #d3ddd9;
  border-radius: 8px;
  color: #344941;
  outline: none;
  background: #fff;
  font-size: 12px;
}

.drive-command-bar {
  min-height: 56px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 8px 22px;
  background: #fbfcfc;
  gap: 12px;
}

.drive-command-bar.selection-active {
  justify-content: space-between;
  background: #f0f6f3;
}

.create-action-wrap {
  position: relative;
  flex: 0 0 auto;
  margin-left: 3px;
  padding-left: 10px;
  border-left: 1px solid #dfe6e3;
}

.create-primary {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 11px;
  color: #fff;
  background: #176d54;
  box-shadow: 0 1px 2px rgba(18, 73, 56, 0.18);
}

.create-primary:hover {
  color: #fff;
  background: #105f49;
  transform: translateY(-1px);
}

.create-primary[aria-disabled=true] {
  box-shadow: none;
  cursor: default;
  opacity: 0.45;
}

.create-primary svg {
  width: 20px;
  height: 20px;
  stroke-width: 2;
}

.create-primary[aria-expanded=true] {
  box-shadow: 0 0 0 3px rgba(23, 109, 84, 0.16);
}

.create-menu {
  position: absolute;
  z-index: 12;
  top: calc(100% + 7px);
  right: 0;
  width: 250px;
  box-sizing: border-box;
  padding: 6px;
  border: 1px solid #d9e2de;
  border-radius: 11px;
  background: #fff;
  box-shadow: 0 16px 38px rgba(27, 52, 43, 0.16), 0 2px 8px rgba(27, 52, 43, 0.06);
}

.create-menu button,
.create-menu label {
  width: 100%;
  min-height: 54px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  color: #344b42;
  background: transparent;
  cursor: pointer;
  text-align: left;
  gap: 11px;
}

.create-menu button:hover,
.create-menu label:hover {
  background: #f1f5f3;
}

.create-menu svg {
  width: 20px;
  height: 20px;
  flex: 0 0 auto;
  fill: none;
  stroke: #27765c;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.create-menu span,
.create-menu strong,
.create-menu small {
  display: block;
}

.create-menu strong {
  font-size: 13px;
}

.create-menu small {
  margin-top: 3px;
  color: #697a73;
  font-size: 11px;
  font-weight: 500;
}

.create-upload input {
  display: none;
}

.list-utilities {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  margin-left: auto;
  gap: 7px;
}

.selection-summary,
.selection-tools {
  display: flex;
  align-items: center;
}

.selection-summary {
  min-width: 0;
  padding-left: 2px;
}

.selection-summary strong {
  color: #174f3e;
  font-size: 13px;
}

.selection-tools {
  gap: 7px;
}

.delete-action {
  color: #a14743;
}

.delete-action:hover:not(:disabled) {
  color: #9c3b37;
  background: #f8e9e7;
}

.trash-entry-action {
  color: #66776f;
}

.trash-entry-action:hover {
  color: #394f46;
  background: #e9eeec;
}

.restore-action {
  color: #176d54;
}

.restore-action:hover:not(:disabled) {
  color: #0f5d47;
  background: #dfeee8;
}

.trash-retention-note {
  min-width: 0;
  display: flex;
  align-items: center;
  color: #53675e;
  font-size: 12px;
  gap: 7px;
}

.trash-retention-note svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  fill: none;
  stroke: #71877e;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.selection-cancel {
  color: #5e716a;
}

.selection-cancel:hover {
  color: #334a41;
  background: #dde8e4;
}

.drive-shell {
  min-height: 620px;
  display: grid;
  overflow: hidden;
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(30, 50, 43, 0.03);
  grid-template-columns: minmax(0, 1fr);
}

.drive-panel {
  position: relative;
  min-width: 0;
  min-height: inherit;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.drive-loading-bar {
  position: absolute;
  z-index: 3;
  top: 0;
  right: 0;
  left: 0;
  height: 3px;
  overflow: hidden;
  background: #dceae5;
}

.drive-loading-bar i {
  position: absolute;
  width: 34%;
  height: 100%;
  background: #248765;
  animation: drive-loading 1s ease-in-out infinite;
}

@keyframes drive-loading {
  from {
    transform: translateX(-110%);
  }
  to {
    transform: translateX(300%);
  }
}
.breadcrumbs {
  min-width: 0;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  overflow: hidden;
  gap: 4px;
}

.breadcrumbs button {
  max-width: 220px;
  overflow: hidden;
  padding: 6px 7px;
  border: 0;
  border-radius: 6px;
  color: #2f4940;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.breadcrumbs button.current {
  color: #172f27;
  font-weight: 800;
  cursor: default;
}

.breadcrumbs button:hover {
  background: #f0f3f2;
}

.breadcrumbs svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  fill: none;
  stroke: #9aa6a1;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.breadcrumb-overflow {
  min-width: 25px;
  height: 25px;
  display: grid;
  border-radius: 6px;
  place-items: center;
  color: #72817b;
  background: #f0f3f2;
  font-size: 14px;
  font-weight: 750;
}

.location-count {
  color: #697a73;
  font-size: 11px;
  white-space: nowrap;
}

.status-filters {
  min-width: 0;
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  overflow-x: auto;
  gap: 7px;
}

.status-filters button {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  padding: 0 11px;
  border: 1px solid #d6dfdb;
  border-radius: 8px;
  color: #4f625a;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  gap: 6px;
}

.status-filters button:hover {
  background: #f7f9f8;
}

.status-filters button.active {
  border-color: #7fae9d;
  color: #0d684e;
  background: #edf6f2;
  font-weight: 750;
}

.status-filters small {
  color: #6f7f78;
  font-size: 11px;
}

.drive-content {
  min-height: 380px;
  flex: 1;
  box-sizing: border-box;
  padding: 22px;
}

.folder-loading-state {
  min-height: 330px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667770;
  gap: 14px;
}

.folder-loading-state > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.folder-loading-state strong {
  color: #34483f;
  font-size: 13px;
}

.folder-loading-state span:not(.state-spinner) {
  font-size: 11px;
}

.drive-list {
  overflow: hidden;
  border: 1px solid #e0e7e4;
  border-radius: 11px;
  background: #fff;
}

.drive-head,
.drive-row {
  width: 100%;
  display: grid;
  align-items: center;
  box-sizing: border-box;
  padding: 0 14px;
  grid-template-columns: minmax(220px, 1.6fr) 100px 150px 76px 88px 24px;
  gap: 12px;
}

.drive-head {
  min-height: 42px;
  border-bottom: 1px solid #e2e8e5;
  color: #61736b;
  background: #fafbfb;
  font-size: 12px;
  font-weight: 700;
}

.sort-button {
  min-width: 0;
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  color: inherit;
  background: transparent;
  cursor: pointer;
  font: inherit;
  gap: 4px;
}

.sort-button:hover,
.sort-button.active {
  color: #326e59;
}

.sort-button:focus-visible {
  border-radius: 4px;
  outline: 2px solid #7eae9d;
  outline-offset: 2px;
}

.sort-button svg {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
  opacity: 0.45;
}

.sort-button.active svg {
  opacity: 1;
}

.sort-button.active:not(.desc) .sort-down,
.sort-button.active.desc .sort-up {
  opacity: 0;
}

.drive-row {
  min-height: 64px;
  border: 0;
  border-bottom: 1px solid #edf1ef;
  color: #4f625a;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  text-align: left;
}

.drive-row:focus-visible {
  outline: 2px solid #55937e;
  outline-offset: -2px;
}

.drive-row:last-of-type {
  border-bottom: 0;
}

.drive-row:hover,
.drive-row.is-previewed {
  background: #f5f8f7;
}

.drive-row.is-previewed {
  box-shadow: inset -3px 0 #3d8c70;
}

.file-row:not([draggable=true]) {
  cursor: default;
}

.drive-row.is-selected {
  background: #edf5f2;
  box-shadow: inset 3px 0 #3d8c70;
}

.drive-row[draggable=true] {
  cursor: grab;
}

.drive-row[draggable=true]:active {
  cursor: grabbing;
}

.drive-row.is-dragging {
  opacity: 0.46;
}

.drive-row.is-drop-target {
  position: relative;
  z-index: 2;
  background: #e6f3ee;
  box-shadow: inset 0 0 0 2px #4b957b;
}

.drive-row.is-drop-target .folder-list-icon,
.drive-row.is-drop-target .parent-folder-icon {
  color: #176d54;
  background: #d7ebe3;
}

.move-progress {
  min-height: 42px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  border: 1px solid #d4e5de;
  border-radius: 9px;
  margin-bottom: 10px;
  color: #315f50;
  background: #f0f7f4;
  font-size: 12px;
  gap: 9px;
}

.move-progress .state-spinner {
  width: 16px;
  height: 16px;
}

.drive-head.trash-drive-head,
.drive-row.trash-row {
  grid-template-columns: minmax(220px, 1.45fr) 120px minmax(180px, 1fr) 130px 100px;
}

.trash-row.is-unavailable {
  cursor: default;
  opacity: 0.58;
}

.trash-row.is-unavailable:hover {
  background: #fff;
}

.trash-row.is-unavailable .item-name-copy small {
  color: #a4433f;
}

.trash-location {
  overflow: hidden;
  color: #52665e;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trash-expiry-column {
  color: #65766f;
  font-size: 11px;
}

.trash-expiry-badge {
  min-width: 42px;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 8px;
  border-radius: 999px;
  color: #51675e;
  background: #edf2f0;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.trash-expiry-badge.warning {
  color: #8a5b18;
  background: #fff3d9;
}

.trash-expiry-badge.critical {
  color: #a33e39;
  background: #fde7e5;
}

.trash-document-icon {
  color: #687970;
  background: #edf2f0;
}

.trash-warning {
  margin: 14px 2px 0;
  color: #9b5e32;
  font-size: 12px;
}

.trash-empty .empty-icon {
  color: #7e8d87;
}

.folder-row[aria-selected=true],
.file-row[aria-selected=true] {
  color: #355148;
}

.parent-folder-row {
  min-height: 52px;
  color: #52665e;
  background: #fbfcfc;
}

.parent-folder-row:hover {
  color: #285a49;
  background: #f1f6f4;
}

.parent-folder-row .item-leading {
  height: 32px;
}

.parent-folder-row .item-name-copy strong {
  color: #3f584f;
  font-weight: 750;
}

.parent-folder-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 31px;
  height: 31px;
  display: grid;
  border: 1px solid #d4dfda;
  border-radius: 8px;
  place-items: center;
  color: #4f7769;
  background: #fff;
  transform: translate(-50%, -50%);
}

.parent-folder-icon svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.parent-row-action {
  color: #6d8179;
}

.folder-list-icon {
  width: 33px;
  height: 31px;
  display: grid;
  flex: 0 0 auto;
  border-radius: 7px;
  place-items: center;
  color: #a8751d;
  background: #f6ead1;
}

.folder-list-icon svg {
  width: 21px;
  height: 21px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.type-cell,
.type-cell strong,
.type-cell small {
  display: block;
  min-width: 0;
}

.type-cell strong {
  overflow: hidden;
  color: #52665e;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.type-cell small {
  margin-top: 3px;
  color: #718078;
  font-size: 11px;
}

.muted-cell {
  color: #7f8d87;
}

.row-action {
  display: grid;
  place-items: center;
  color: #929e99;
}

.row-action svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.preview-action-button {
  width: 28px;
  height: 28px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 7px;
  place-items: center;
  color: #889690;
  background: transparent;
  cursor: pointer;
}

.preview-action-button:hover,
.preview-action-button.active {
  color: #216e53;
  background: #e7f1ed;
}

.preview-action-button:focus-visible {
  outline: 2px solid #69a48f;
  outline-offset: 2px;
}

.preview-action-button svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.drive-context-menu {
  position: fixed;
  z-index: 88;
  width: 224px;
  box-sizing: border-box;
  padding: 6px;
  border: 1px solid #dce3e0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 16px 42px rgba(22, 43, 36, 0.18), 0 2px 8px rgba(22, 43, 36, 0.08);
  backdrop-filter: blur(12px);
}

.drive-context-menu header {
  min-width: 0;
  padding: 8px 10px 9px;
  border-bottom: 1px solid #edf0ef;
  margin-bottom: 4px;
}

.drive-context-menu header span,
.drive-context-menu header strong {
  display: block;
}

.drive-context-menu header span {
  margin-bottom: 3px;
  color: #6f7f78;
  font-size: 11px;
}

.drive-context-menu header strong {
  overflow: hidden;
  color: #2b4038;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drive-context-menu button,
.drive-context-menu .context-upload {
  width: 100%;
  min-height: 36px;
  display: flex;
  align-items: center;
  padding: 0 9px;
  border: 0;
  border-radius: 6px;
  color: #40544d;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  text-align: left;
  gap: 10px;
}

.drive-context-menu button:hover,
.drive-context-menu .context-upload:hover {
  background: #f0f3f2;
}

.drive-context-menu .context-upload input {
  display: none;
}

.drive-context-menu button:disabled {
  cursor: default;
  opacity: 0.45;
}

.drive-context-menu button.danger {
  color: #a4433f;
}

.drive-context-menu button.danger:hover {
  background: #fff3f2;
}

.drive-context-menu button svg,
.drive-context-menu .context-upload svg {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.context-divider {
  height: 1px;
  margin: 5px 4px;
  background: #e8edeb;
}

.name-cell {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}

.list-name-heading {
  display: flex;
  align-items: center;
  gap: 11px;
}

.item-leading {
  position: relative;
  width: 33px;
  height: 35px;
  flex: 0 0 33px;
}

.item-leading > .folder-list-icon,
.item-leading > .document-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  pointer-events: none;
  transition: opacity 0.14s ease, transform 0.14s ease;
  transform: translate(-50%, -50%);
}

.item-selection-control,
.select-all-control {
  position: relative;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  cursor: pointer;
}

.item-selection-control {
  position: absolute;
  z-index: 1;
  inset: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.14s ease, transform 0.14s ease;
  transform: scale(0.88);
}

.item-selection-control input,
.select-all-control input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.selection-indicator {
  width: 21px;
  height: 21px;
  display: grid;
  box-sizing: border-box;
  border: 1.5px solid #9aaba4;
  border-radius: 6px;
  place-items: center;
  color: transparent;
  background: #fff;
  box-shadow: 0 1px 2px rgba(31, 57, 48, 0.08);
  transition: border-color 0.14s ease, color 0.14s ease, background 0.14s ease, box-shadow 0.14s ease;
}

.selection-indicator svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2.2;
}

.selection-minus {
  display: none;
}

.item-selection-control:hover .selection-indicator,
.select-all-control:hover .selection-indicator {
  border-color: #4e8e77;
  box-shadow: 0 0 0 3px rgba(45, 126, 96, 0.1);
}

.item-selection-control:focus-within .selection-indicator,
.select-all-control:focus-within .selection-indicator {
  outline: 2px solid #4b957b;
  outline-offset: 2px;
}

.item-selection-control.is-selected .selection-indicator,
.select-all-control.is-selected .selection-indicator,
.select-all-control.is-indeterminate .selection-indicator {
  border-color: #24775c;
  color: #fff;
  background: #24775c;
}

.select-all-control.is-indeterminate .selection-check {
  display: none;
}

.select-all-control.is-indeterminate .selection-minus {
  display: block;
}

.drive-row:hover .item-selection-control,
.drive-row:focus-within .item-selection-control,
.drive-row.is-selected .item-selection-control {
  opacity: 1;
  pointer-events: auto;
  transform: scale(1);
}

.drive-row:hover .item-leading > .folder-list-icon,
.drive-row:hover .item-leading > .document-icon,
.drive-row:focus-within .item-leading > .folder-list-icon,
.drive-row:focus-within .item-leading > .document-icon,
.drive-row.is-selected .item-leading > .folder-list-icon,
.drive-row.is-selected .item-leading > .document-icon {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.86);
}

.name-cell > span,
.name-cell strong,
.name-cell small {
  display: block;
  min-width: 0;
}

.name-cell strong {
  overflow: hidden;
  color: #263b34;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name-cell small {
  overflow: hidden;
  margin-top: 3px;
  color: #6f7f78;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-icon {
  width: 31px;
  height: 35px;
  display: grid;
  flex: 0 0 auto;
  border: 1px solid #cbdad4;
  border-radius: 5px;
  place-items: center;
  color: #237258;
  background: #edf5f2;
  font-size: 7px;
  font-style: normal;
  font-weight: 850;
}

.status-cell {
  display: grid;
  align-items: center;
  color: #52665e;
  font-size: 12px;
  grid-template-columns: 6px minmax(0, 1fr) 24px;
  gap: 7px;
}

.status-cell i {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #c4ccc9;
}

.status-cell.ready {
  color: #137252;
  font-weight: 700;
}

.status-cell.ready i {
  background: #28a474;
}

.status-cell.processing {
  color: #276d58;
}

.status-cell.processing i {
  background: #4d9b80;
}

.status-cell.failed {
  color: #ab4d47;
}

.status-cell.failed i {
  background: #cc645c;
}

.ocr-status-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.ocr-status-label {
  overflow: hidden;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ocr-progress-track {
  width: 100%;
  height: 3px;
  overflow: hidden;
  border-radius: 999px;
  background: #dbe8e3;
}

.ocr-progress-value {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: #378467;
  transition: width 0.25s ease;
}

.ocr-manager-button {
  width: 24px;
  height: 24px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 7px;
  place-items: center;
  color: #668078;
  background: transparent;
  cursor: pointer;
}

.ocr-manager-button:hover,
.ocr-manager-button:focus-visible {
  color: #176d54;
  background: #e8f2ee;
}

.ocr-manager-button.attention {
  color: #a94d46;
  background: #fcedeb;
}

.ocr-manager-button svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.chevron {
  display: grid;
  place-items: center;
  color: #8d9994;
}

.chevron svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
  transition: transform 0.15s ease;
}

.chevron.open svg {
  transform: rotate(180deg);
}

.document-preview-panel {
  position: fixed;
  z-index: 80;
  top: 0;
  right: 0;
  bottom: 0;
  width: clamp(520px, 48vw, 780px);
  min-width: 0;
  min-height: 0;
  height: 100vh;
  height: 100dvh;
  display: flex;
  overflow: hidden;
  border-left: 1px solid #dde6e2;
  flex-direction: column;
  background: #f7f9f8;
  box-shadow: -18px 0 48px rgba(24, 45, 37, 0.17);
}

.preview-heading {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 15px 16px 13px 18px;
  border-bottom: 1px solid #e0e7e4;
  gap: 12px;
}

.preview-heading > div {
  min-width: 0;
}

.preview-heading span {
  display: block;
  margin-bottom: 3px;
  color: #60726a;
  font-size: 11px;
  font-weight: 700;
}

.preview-heading h2 {
  overflow: hidden;
  margin: 0;
  color: #263c34;
  font-size: 16px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview-heading button {
  width: 34px;
  height: 34px;
  display: grid;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-radius: 9px;
  place-items: center;
  color: #60726a;
  background: transparent;
  cursor: pointer;
}

.preview-heading button:hover {
  color: #263c34;
  background: #e8eeeb;
}

.preview-heading svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 1.8;
}

.preview-tabs {
  min-height: 46px;
  display: flex;
  align-items: flex-end;
  overflow-x: auto;
  box-sizing: border-box;
  padding: 0 14px;
  border-bottom: 1px solid #dfe7e3;
  background: #fff;
  gap: 4px;
}

.preview-tabs button {
  position: relative;
  min-height: 45px;
  padding: 0 10px;
  border: 0;
  color: #596c64;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: 750;
  white-space: nowrap;
}

.preview-tabs button:hover,
.preview-tabs button.active {
  color: #236b52;
}

.preview-tabs button.active::after {
  position: absolute;
  right: 8px;
  bottom: 0;
  left: 8px;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: #2f8365;
  content: "";
}

.preview-body {
  min-height: 0;
  display: flex;
  overflow: hidden;
  flex: 1 1 auto;
  background: #eef2f0;
}

.preview-pdf {
  width: 100%;
  min-height: 0;
  border: 0;
  flex: 1 1 auto;
  background: #fff;
}

.preview-text {
  width: 100%;
  min-width: 0;
  min-height: 100%;
  overflow: auto;
  box-sizing: border-box;
  padding: 22px 20px;
  margin: 0;
  color: #31463e;
  background: #fff;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}

.preview-state {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 24px;
  color: #61736b;
  text-align: center;
  gap: 8px;
}

.preview-state strong {
  color: #40534b;
  font-size: 14px;
}

.preview-state span {
  font-size: 12px;
}

.preview-error strong {
  color: #9d4944;
}

.preview-limit-note {
  padding: 8px 14px;
  margin: 0;
  border-top: 1px solid #eadab9;
  color: #775c2e;
  background: #fff8e8;
  font-size: 11px;
}

.preview-footer {
  min-height: 42px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-top: 1px solid #dfe7e3;
  color: #596c64;
  background: #fff;
  font-size: 11px;
  gap: 8px;
}

.preview-footer span + span::before {
  margin-right: 8px;
  color: #bbc5c0;
  content: "·";
}

.preview-ocr-status {
  color: #257458;
  font-weight: 750;
}

.empty-drive,
.state-card {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #61736b;
  font-size: 12px;
  gap: 7px;
}

.state-card {
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  background: #fff;
}

.empty-drive strong,
.state-card strong {
  color: #34483f;
  font-size: 14px;
}

.empty-icon {
  width: 50px;
  height: 50px;
  display: grid;
  margin-bottom: 4px;
  border-radius: 14px;
  place-items: center;
  color: #95a49e;
  background: #f0f3f2;
}

.empty-icon svg {
  width: 27px;
  height: 27px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5;
}

.loading-state {
  gap: 12px;
}

.state-spinner {
  width: 22px;
  height: 22px;
  box-sizing: border-box;
  border: 2px solid #d9e5e0;
  border-top-color: #1b795a;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.filtered-empty button {
  margin-top: 5px;
  padding: 8px 12px;
  border: 1px solid #ccd8d2;
  border-radius: 8px;
  color: #286851;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
}

.drive-pagination {
  min-height: 54px;
  display: grid;
  align-items: center;
  margin-top: 12px;
  padding: 0 6px;
  grid-template-columns: minmax(120px, 1fr) auto minmax(120px, 1fr);
  color: #596c64;
  font-size: 12px;
  gap: 16px;
}

.pagination-summary {
  font-variant-numeric: tabular-nums;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

.pagination-controls button {
  width: 30px;
  height: 30px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 8px;
  place-items: center;
  color: #62736b;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: 750;
}

.pagination-controls button:hover:not(:disabled) {
  color: #286851;
  background: #edf4f1;
}

.pagination-controls button.active {
  color: #fff;
  background: #367c63;
}

.pagination-controls button:disabled {
  cursor: default;
  opacity: 0.3;
}

.pagination-arrow svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.pagination-ellipsis {
  width: 20px;
  text-align: center;
}

.page-size-control {
  display: inline-flex;
  align-items: center;
  justify-self: end;
  gap: 7px;
}

.page-size-control select {
  min-width: 68px;
  height: 30px;
  padding: 0 24px 0 9px;
  border: 1px solid #d8e1dd;
  border-radius: 8px;
  color: #53675e;
  background: #fff;
  font-size: 12px;
}

.dialog-backdrop {
  position: fixed;
  z-index: 90;
  inset: 0;
  display: grid;
  padding: 20px;
  place-items: center;
  background: rgba(25, 41, 36, 0.36);
}

.new-folder-dialog {
  width: min(400px, 100%);
  box-sizing: border-box;
  padding: 22px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 18px 50px rgba(20, 39, 32, 0.2);
}

.new-folder-dialog h2 {
  margin: 0;
  color: #263c34;
  font-size: 18px;
}

.new-folder-dialog p {
  margin: 6px 0 18px;
  color: #61736b;
  font-size: 12px;
}

.new-folder-dialog input {
  width: 100%;
  height: 42px;
  box-sizing: border-box;
  padding: 0 11px;
  border: 1px solid #bfcfc8;
  border-radius: 8px;
  color: #2e433b;
  outline: none;
  font-size: 12px;
}

.new-folder-dialog input:focus {
  border-color: #4c947b;
  box-shadow: 0 0 0 3px rgba(35, 125, 94, 0.1);
}

.new-folder-dialog > div {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 8px;
}

.ocr-manager-dialog {
  width: min(500px, 100%);
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid #dce5e1;
  border-radius: 16px;
  color: #31473e;
  background: #fff;
  box-shadow: 0 22px 64px rgba(20, 39, 32, 0.24);
}

.ocr-manager-dialog > header {
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #edf1ef;
}

.ocr-manager-dialog > header span {
  display: block;
  margin-bottom: 3px;
  color: #6e8179;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ocr-manager-dialog h2 {
  margin: 0;
  color: #243b32;
  font-size: 18px;
}

.ocr-manager-dialog > header button {
  width: 32px;
  height: 32px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 8px;
  place-items: center;
  color: #72827c;
  background: transparent;
  cursor: pointer;
}

.ocr-manager-dialog > header button:hover {
  color: #294a3e;
  background: #f0f4f2;
}

.ocr-manager-dialog > header svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 1.8;
}

.ocr-manager-document {
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 18px 20px 12px;
  gap: 11px;
}

.ocr-manager-document > i {
  width: 34px;
  height: 38px;
  display: grid;
  flex: 0 0 auto;
  border: 1px solid #cbdad4;
  border-radius: 6px;
  place-items: center;
  color: #237258;
  background: #edf5f2;
  font-size: 8px;
  font-style: normal;
  font-weight: 850;
}

.ocr-manager-document > div {
  min-width: 0;
}

.ocr-manager-document strong,
.ocr-manager-document span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ocr-manager-document strong {
  color: #2b4038;
  font-size: 13px;
}

.ocr-manager-document span {
  margin-top: 4px;
  color: #718078;
  font-size: 11px;
}

.ocr-manager-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #f0f3f2;
  border-bottom: 1px solid #f0f3f2;
  color: #3b6959;
  background: #f5f9f7;
  gap: 12px;
}

.ocr-manager-status > span {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 800;
}

.ocr-manager-status > small {
  color: #64766f;
  font-size: 11px;
  text-align: right;
}

.ocr-manager-status.failed {
  color: #a34742;
  background: #fff6f5;
}

.ocr-dialog-progress {
  height: 4px;
  display: block;
  overflow: hidden;
  background: #dce9e4;
}

.ocr-dialog-progress > span {
  height: 100%;
  display: block;
  background: #378467;
  transition: width 0.25s ease;
}

.ocr-job-metadata {
  display: grid;
  padding: 14px 20px 4px;
  margin: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.ocr-job-metadata > div {
  min-width: 0;
  padding: 10px 11px;
  border-radius: 9px;
  background: #f7f9f8;
}

.ocr-job-metadata dt {
  margin-bottom: 4px;
  color: #788881;
  font-size: 10px;
}

.ocr-job-metadata dd {
  overflow: hidden;
  margin: 0;
  color: #354b42;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ocr-error-detail {
  padding: 14px;
  border: 1px solid #f0d2cf;
  border-radius: 10px;
  margin: 12px 20px 0;
  color: #773b37;
  background: #fff7f6;
}

.ocr-error-detail > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.ocr-error-detail strong {
  font-size: 12px;
}

.ocr-error-detail code {
  overflow-wrap: anywhere;
  color: #9f4842;
  font-size: 10px;
}

.ocr-error-detail p,
.ocr-manager-note {
  margin: 8px 0 0;
  line-height: 1.55;
  font-size: 11px;
  white-space: pre-wrap;
}

.ocr-manager-note {
  padding: 11px 13px;
  border-radius: 9px;
  margin: 12px 20px 0;
  color: #50675e;
  background: #eef4f1;
}

.ocr-manager-dialog > footer {
  display: flex;
  justify-content: flex-end;
  padding: 18px 20px 20px;
  gap: 8px;
}

.ocr-cancel-button {
  min-height: 36px;
  padding: 0 13px;
  border: 1px solid #e7c2bf;
  border-radius: 8px;
  color: #a34640;
  background: #fff;
  font-size: 12px;
  font-weight: 750;
}

.ocr-cancel-button:hover {
  background: #fff4f3;
}

.ocr-manager-dialog button:disabled {
  cursor: default;
  opacity: 0.56;
}

.text-button,
.primary-button {
  min-height: 36px;
  padding: 0 13px;
  border: 0;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 750;
}

.text-button {
  color: #5f716a;
  background: transparent;
}

.text-button:hover {
  background: #f0f3f2;
}

.primary-button {
  color: #fff;
  background: #176d54;
}

.primary-button:hover {
  background: #105d47;
}

.primary-button:disabled {
  opacity: 0.58;
}

.upload-tray {
  position: fixed;
  z-index: 70;
  right: 24px;
  bottom: 24px;
  width: min(440px, 100vw - 48px);
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid #d4deda;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 15px 46px rgba(20, 39, 32, 0.2);
}

.upload-tray-heading {
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  color: #fff;
  background: #244a3f;
  gap: 15px;
}

.upload-tray-heading > div,
.upload-tray-heading strong,
.upload-tray-heading span {
  display: block;
  min-width: 0;
}

.upload-tray-heading strong {
  overflow: hidden;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-tray-heading span {
  margin-top: 3px;
  color: #c9ddd6;
  font-size: 11px;
}

.upload-tray-heading .close-button {
  color: #d6e4df;
}

.upload-tray-heading .close-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.upload-settings {
  display: grid;
  padding: 14px 15px 0;
  grid-template-columns: 1fr 1fr 1.2fr;
  gap: 8px;
}

.upload-settings label {
  min-width: 0;
  display: flex;
  flex-direction: column;
  color: #52665e;
  font-size: 11px;
  font-weight: 700;
  gap: 5px;
}

.upload-settings select,
.upload-settings input {
  width: 100%;
  height: 34px;
  box-sizing: border-box;
  padding: 0 8px;
  border: 1px solid #d3ddd8;
  border-radius: 7px;
  color: #2f413a;
  outline: none;
  background: #fff;
  font-size: 12px;
}

.upload-files {
  max-height: 160px;
  display: grid;
  overflow-y: auto;
  padding: 12px 15px 0;
  gap: 5px;
}

.upload-files > div {
  display: grid;
  align-items: center;
  padding: 7px 8px;
  border: 1px solid #e0e7e4;
  border-radius: 7px;
  background: #fafbfb;
  grid-template-columns: 32px minmax(0, 1fr) auto auto;
  gap: 8px;
}

.upload-files strong {
  overflow: hidden;
  color: #34473f;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-files small {
  color: #65766f;
  font-size: 11px;
}

.upload-files button {
  border: 0;
  color: #84918c;
  background: transparent;
  font-size: 15px;
}

.file-type {
  width: 28px;
  height: 24px;
  display: grid;
  border-radius: 4px;
  place-items: center;
  color: #267158;
  background: #eaf3ef;
  font-size: 7px;
  font-weight: 800;
}

.upload-submit {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 14px 15px;
  gap: 10px;
}

.upload-submit .primary-button {
  margin-left: auto;
}

.upload-progress-copy {
  display: flex;
  align-items: center;
  color: #53675e;
  font-size: 12px;
  gap: 7px;
}

.upload-progress-copy strong {
  color: #176d54;
}

.progress {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  overflow: hidden;
  background: #dce7e2;
}

.progress i {
  display: block;
  height: 100%;
  background: #2a9a70;
}

.drop-overlay {
  position: fixed;
  z-index: 80;
  top: 76px;
  right: 24px;
  bottom: 24px;
  left: calc(var(--sidebar-width, 216px) + 24px);
  display: grid;
  border: 2px dashed #388b6f;
  border-radius: 16px;
  place-content: center;
  color: #175e47;
  background: rgba(244, 249, 247, 0.97);
  box-shadow: inset 0 0 0 8px rgba(255, 255, 255, 0.72);
  text-align: center;
  pointer-events: none;
}

.drop-icon {
  width: 54px;
  height: 54px;
  display: grid;
  margin: 0 auto 12px;
  border-radius: 16px;
  place-items: center;
  color: #247b5d;
  background: #dceee7;
}

.drop-icon svg {
  width: 27px;
  height: 27px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.drop-overlay strong {
  font-size: 18px;
}

.drop-overlay > span:last-child {
  margin-top: 5px;
  color: #5f7d72;
  font-size: 11px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

@media (max-width: 1180px) {
  .drive-navigation-bar {
    gap: 14px;
  }
  .navigation-tools {
    flex-basis: 520px;
  }
  .drive-search {
    width: min(400px, 100%);
  }
  .location-count {
    display: none;
  }
  .drive-head,
  .drive-row {
    grid-template-columns: minmax(220px, 1.6fr) 100px 142px 82px 24px;
  }
  .drive-head.trash-drive-head,
  .drive-row.trash-row {
    grid-template-columns: minmax(220px, 1.4fr) 105px minmax(150px, 1fr) 120px 90px;
  }
  .size-column {
    display: none;
  }
}
@media (max-width: 920px) {
  .source-drive {
    padding: 20px 18px 32px;
  }
  .document-preview-panel {
    z-index: 80;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    min-height: 0;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .preview-body,
  .preview-pdf {
    min-height: 0;
  }
  .drive-navigation-bar {
    align-items: stretch;
    flex-direction: column;
    padding: 14px 18px;
    gap: 10px;
  }
  .navigation-tools {
    width: 100%;
    flex-basis: auto;
    justify-content: stretch;
  }
  .drive-search {
    width: auto;
    max-width: none;
    flex: 1 1 auto;
  }
  .drive-command-bar {
    padding-right: 18px;
    padding-left: 18px;
  }
  .status-filters {
    flex: 1 1 auto;
  }
  .drive-head,
  .drive-row {
    grid-template-columns: minmax(210px, 1fr) 136px 82px 24px;
  }
  .drive-head.trash-drive-head,
  .drive-row.trash-row {
    grid-template-columns: minmax(210px, 1fr) minmax(150px, 0.8fr) 120px 90px;
  }
  .type-column,
  .size-column {
    display: none;
  }
  .drop-overlay {
    inset: 76px 16px 16px;
  }
}
@media (max-width: 700px) {
  .source-drive {
    padding: 16px 12px 28px;
  }
  .organization-select > span {
    display: none;
  }
  .organization-select {
    width: 100%;
  }
  .organization-select select {
    width: 100%;
    max-width: none;
  }
  .drive-shell {
    display: block;
    min-height: 0;
  }
  .drive-navigation-bar {
    padding: 12px 14px;
  }
  .navigation-tools {
    align-items: stretch;
    flex-direction: column;
  }
  .breadcrumbs button {
    max-width: 130px;
    font-size: 12px;
  }
  .drive-search {
    min-width: 0;
  }
  .drive-command-bar {
    min-height: 0;
    flex-wrap: wrap;
    padding: 9px 14px;
    gap: 8px;
  }
  .drive-command-bar.selection-active {
    flex-wrap: nowrap;
  }
  .create-primary {
    width: 38px;
    height: 38px;
  }
  .status-filters {
    width: 100%;
    flex-basis: 100%;
    order: 3;
  }
  .trash-retention-note {
    width: 100%;
    flex: 1 1 100%;
    order: 3;
  }
  .list-utilities {
    flex: 1 1 auto;
    justify-content: flex-end;
  }
  .selection-tools {
    margin-left: auto;
  }
  .drive-content {
    min-height: 320px;
    padding: 16px 14px;
  }
  .drive-pagination {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 8px 0 0;
    gap: 8px 12px;
  }
  .pagination-controls {
    width: 100%;
    order: 3;
  }
  .page-size-control {
    justify-self: auto;
  }
  .drive-head {
    display: none;
  }
  .drive-head.trash-drive-head {
    display: none;
  }
  .unified-drive-list.has-selection .drive-head {
    min-height: 40px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 24px;
  }
  .drive-list {
    border-radius: 9px;
  }
  .drive-row {
    grid-template-columns: minmax(0, 1fr) 24px;
    gap: 8px;
  }
  .drive-row.trash-row {
    grid-template-columns: minmax(0, 1fr);
  }
  .ocr-manager-dialog {
    max-height: calc(100vh - 32px);
    overflow-y: auto;
  }
  .ocr-manager-status {
    align-items: flex-start;
    flex-direction: column;
  }
  .ocr-manager-status > small {
    text-align: left;
  }
  .ocr-job-metadata {
    grid-template-columns: 1fr;
  }
  .type-column,
  .status-column,
  .size-column,
  .date-column,
  .trash-location-column,
  .trash-expiry-column {
    display: none;
  }
  .upload-tray {
    right: 12px;
    bottom: 12px;
    width: calc(100vw - 24px);
  }
  .upload-settings {
    grid-template-columns: 1fr 1fr;
  }
  .upload-settings label:last-child {
    grid-column: 1/-1;
  }
}
@media (hover: none) {
  .command-icon-button[data-tooltip]::before,
  .command-icon-button[data-tooltip]::after {
    display: none;
  }
  .item-selection-control {
    opacity: 1;
    pointer-events: auto;
    transform: scale(1);
  }
  .item-leading > .folder-list-icon,
  .item-leading > .document-icon {
    opacity: 0;
  }
}`],
})
export class PageAuthoringSourcesComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public uploading: boolean = false;
    public uploadProgress: number = 0;
    public dragActive: boolean = false;
    public draggingDriveItems: any[] = [];
    public dragOverFolderId: string | null = null;
    public moving: boolean = false;
    public assets: any[] = [];
    public folders: any[] = [];
    public breadcrumbs: any[] = [];
    public organizations: any[] = [];
    public currentFolder: any = null;
    public selectedOrganizationId: string = '';
    public writable: boolean = false;
    public selectedFiles: any[] = [];
    public showNewFolder: boolean = false;
    public showCreateMenu: boolean = false;
    public newFolderName: string = '';
    public creatingFolder: boolean = false;
    public storageMode: boolean = false;
    public totalFolderCount: number = 0;
    public totalDocumentCount: number = 0;
    public statusCounts: any = {};
    public searchTimer: any = null;
    public searchQuery: string = '';
    public statusFilter: string = 'ALL';
    public currentPage: number = 1;
    public pageSize: number = 10;
    public pageSizeOptions: number[] = [10, 20, 50];
    public sortField: string = 'name';
    public sortDirection: string = 'asc';
    public selectedDriveItems: any[] = [];
    public lastSelectedDriveKey: string = '';
    public renameTarget: any = null;
    public renameName: string = '';
    public renaming: boolean = false;
    public deleting: boolean = false;
    public trashMode: boolean = false;
    public trashItems: any[] = [];
    public selectedTrashItems: any[] = [];
    public trashQuery: string = '';
    public trashRetentionDays: number = 30;
    public trashBusy: boolean = false;
    public trashCorruptBatchCount: number = 0;
    public previewAsset: any = null;
    public previewFiles: any[] = [];
    public previewFile: any = null;
    public previewMode: string = 'empty';
    public previewContent: string = '';
    public previewError: string = '';
    public previewTruncated: boolean = false;
    public previewUrl: SafeResourceUrl | null = null;
    public ocrManagerAsset: any = null;
    public ocrActionBusy: boolean = false;
    public contextMenu: any = {
        visible: false,
        x: 0,
        y: 0,
        kind: 'blank',
        label: '',
        item: null
    };
    private loadRequestId: number = 0;
    private internalDragType: string = 'application/x-kiom-storage-items';
    private driveDragPreviewElement: HTMLElement | null = null;
    private folderViewStates: any = {};
    private previewRequestId: number = 0;
    private ocrRefreshTimer: any = null;
    private ocrRefreshInFlight: boolean = false;
    private destroyed: boolean = false;
    private popStateHandler: any = async () => {
        await this.restoreDriveUrlState();
    };
    public form: any = this.emptyForm();

    public statusFilters: any[] = [
        { value: 'ALL', label: '전체' },
        { value: 'READY', label: 'OCR 완료' },
        { value: 'PROCESSING', label: 'OCR 진행 중' },
        { value: 'FAILED', label: 'OCR 실패' }
    ];

    public sourceGroups: any[] = [
        { value: 'CLINICAL_GUIDELINE', label: '진료지침' },
        { value: 'TEXTBOOK', label: '교과서' },
        { value: 'JOURNAL', label: '논문' },
        { value: 'CLASSIC_DB', label: '고전 DB' },
        { value: 'ABSTRACT', label: '학술 초록' },
        { value: 'KNOWLEDGE_PORTAL', label: '지식 포털' },
        { value: 'OTHER', label: '기타' }
    ];

    public rightsStatuses: any[] = [
        { value: 'CLEARED', label: '사용 확인' },
        { value: 'PENDING', label: '권리 검토 중' },
        { value: 'RESTRICTED', label: '제한 사용' },
        { value: 'BLOCKED', label: '사용 차단' }
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( DomSanitizer    )         private sanitizer: DomSanitizer    ) { }

    public emptyForm() {
        return {
            asset_id: '',
            asset_title: '',
            source_group: 'OTHER',
            rights_status: 'CLEARED',
            owner_name: ''
        };
    }

    public async ngOnInit() {
        await this.service.init();
        window.addEventListener('popstate', this.popStateHandler);
        let initialState = this.driveUrlState();
        this.applyDriveState(initialState);
        await this.load(initialState.path, null, 'replace');
    }

    public ngOnDestroy() {
        this.destroyed = true;
        window.removeEventListener('popstate', this.popStateHandler);
        if (this.searchTimer) window.clearTimeout(this.searchTimer);
        this.clearOcrRefreshTimer();
        this.removeDriveDragPreview();
        this.resetDocumentPreview();
        this.ocrManagerAsset = null;
    }

    public canWrite() {
        return this.writable;
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '처리 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    public async load(
        folderId?: string,
        navigationSnapshot: any = null,
        historyMode: string = 'replace'
    ) {
        this.clearOcrRefreshTimer();
        let requestId = ++this.loadRequestId;
        this.resetDocumentPreview();
        this.selectedDriveItems = [];
        this.lastSelectedDriveKey = '';
        this.showCreateMenu = false;
        await this.closeContextMenu();
        this.loading = true;
        await this.service.render();
        try {
            let path = folderId !== undefined
                ? folderId
                : (this.currentFolder ? this.currentFolder.id : '');
            let result: any;
            try {
                result = await this.service.request.post('/api/sources/list', {
                    path: path,
                    query: this.searchQuery,
                    status: this.statusFilter,
                    offset: (this.currentPage - 1) * this.pageSize,
                    limit: this.pageSize,
                    sort_by: this.sortField,
                    sort_direction: this.sortDirection
                });
            } catch (error) {
                if (requestId !== this.loadRequestId) return null;
                if (navigationSnapshot) {
                    this.restoreDriveView(navigationSnapshot);
                    this.loading = false;
                    await this.service.render();
                }
                await this.showError('원천 데이터를 불러오지 못했습니다.');
                return false;
            }
            if (requestId !== this.loadRequestId) return null;
            if (result.code !== 200) {
                if (navigationSnapshot) {
                    this.restoreDriveView(navigationSnapshot);
                    this.loading = false;
                    await this.service.render();
                }
                await this.showError(result.data && result.data.message ? result.data.message : '원천 데이터를 불러오지 못했습니다.');
                return false;
            }
            this.organizations = result.data.organizations || [];
            let selected = result.data.selected_organization || {};
            this.selectedOrganizationId = selected.id || '';
            this.writable = !!result.data.can_write;
            this.storageMode = !!result.data.storage_mode;
            this.currentFolder = result.data.current_folder || null;
            this.breadcrumbs = result.data.breadcrumbs || [];
            let loadedFolders = result.data.folders || [];
            let loadedAssets = (result.data.assets || []).map((asset: any) => {
                asset.expanded = false;
                return asset;
            });
            this.totalFolderCount = Number(result.data.folder_total || 0);
            this.totalDocumentCount = Number(result.data.document_total || 0);
            let lastPage = Math.max(1, Math.ceil(
                (this.totalFolderCount + this.totalDocumentCount) / this.pageSize
            ));
            if (this.currentPage > lastPage) {
                this.currentPage = lastPage;
                return await this.load(folderId, navigationSnapshot, historyMode);
            }
            this.folders = loadedFolders;
            this.assets = loadedAssets;
            this.statusCounts = result.data.status_counts || {};
            this.rememberFolderView(path);
            this.syncDriveUrl(path, historyMode);
            this.scheduleOcrRefresh();
            return true;
        } finally {
            if (requestId === this.loadRequestId) {
                this.loading = false;
                await this.service.render();
            }
        }
    }

    private clearOcrRefreshTimer() {
        if (this.ocrRefreshTimer) {
            window.clearTimeout(this.ocrRefreshTimer);
            this.ocrRefreshTimer = null;
        }
    }

    private hasPendingOcr() {
        return this.assets.some((asset: any) => {
            let version = asset && asset.latest_version;
            let job = version && version.latest_extraction;
            return job && (job.status === 'PENDING' || job.status === 'RUNNING');
        });
    }

    private scheduleOcrRefresh() {
        this.clearOcrRefreshTimer();
        if (
            this.destroyed
            || !this.storageMode
            || this.trashMode
            || !this.hasPendingOcr()
        ) return;
        this.ocrRefreshTimer = window.setTimeout(() => {
            this.refreshOcrStates();
        }, 5000);
    }

    private async refreshOcrStates() {
        if (this.destroyed || this.ocrRefreshInFlight) return;
        if (this.loading || this.uploading || this.trashMode) {
            this.scheduleOcrRefresh();
            return;
        }
        this.ocrRefreshInFlight = true;
        let requestId = this.loadRequestId;
        let path = this.currentFolder ? this.currentFolder.id : '';
        try {
            let result: any = await this.service.request.post('/api/sources/list', {
                path: path,
                query: this.searchQuery,
                status: this.statusFilter,
                offset: (this.currentPage - 1) * this.pageSize,
                limit: this.pageSize,
                sort_by: this.sortField,
                sort_direction: this.sortDirection
            });
            if (
                this.destroyed
                || requestId !== this.loadRequestId
                || result.code !== 200
            ) return;
            let expanded: any = {};
            this.assets.forEach((asset: any) => {
                expanded[asset.id] = !!asset.expanded;
            });
            this.folders = (result.data.folders || []).slice();
            this.assets = (result.data.assets || []).map((asset: any) => {
                asset.expanded = !!expanded[asset.id];
                return asset;
            });
            if (this.ocrManagerAsset) {
                this.ocrManagerAsset = this.assets.find((asset: any) => {
                    return asset.id === this.ocrManagerAsset.id;
                }) || null;
            }
            this.totalFolderCount = Number(result.data.folder_total || 0);
            this.totalDocumentCount = Number(result.data.document_total || 0);
            this.statusCounts = result.data.status_counts || this.statusCounts;
            await this.service.render();
        } catch (error) {
            return;
        } finally {
            this.ocrRefreshInFlight = false;
            this.scheduleOcrRefresh();
        }
    }

    public async changeOrganization(organizationId: string) {
        this.selectedOrganizationId = organizationId;
        this.currentFolder = null;
        this.folderViewStates = {};
        this.cancelUpload();
        this.clearFilters();
        await this.load('', null, 'replace');
    }

    public async openFolder(folder: any) {
        let breadcrumbs = this.folderNavigationBreadcrumbs(folder);
        await this.navigateToFolder(folder.id, {
            id: folder.id,
            name: folder.name
        }, breadcrumbs);
    }

    public async openRoot() {
        if (this.trashMode) {
            await this.closeTrash();
            return;
        }
        await this.navigateToFolder('', null, []);
    }

    public async openTrash() {
        if (!this.canWrite() || this.trashMode) return;
        this.rememberFolderView();
        this.cancelUpload();
        this.clearFilters();
        this.selectedDriveItems = [];
        this.lastSelectedDriveKey = '';
        this.trashMode = true;
        this.trashQuery = '';
        await this.loadTrash();
    }

    public async closeTrash() {
        this.trashMode = false;
        this.trashItems = [];
        this.selectedTrashItems = [];
        this.trashQuery = '';
        this.trashCorruptBatchCount = 0;
        this.restoreFolderView('');
        this.currentFolder = null;
        this.breadcrumbs = [];
        await this.load('', null, 'push');
    }

    private driveUrlState() {
        let params = new URLSearchParams(window.location.search);
        let page = Math.max(1, Number(params.get('page') || 1) || 1);
        let requestedSize = Number(params.get('page_size') || 10);
        let pageSize = this.pageSizeOptions.indexOf(requestedSize) >= 0
            ? requestedSize
            : 10;
        let requestedSort = String(params.get('sort') || 'name');
        let sortField = ['name', 'type', 'ocr', 'size', 'updated'].indexOf(requestedSort) >= 0
            ? requestedSort
            : 'name';
        let sortDirection = params.get('direction') === 'desc' ? 'desc' : 'asc';
        let requestedStatus = String(params.get('ocr') || 'ALL').toUpperCase();
        let statusFilter = ['ALL', 'READY', 'PROCESSING', 'FAILED'].indexOf(requestedStatus) >= 0
            ? requestedStatus
            : 'ALL';
        return {
            path: String(params.get('path') || '').replace(/^\/+|\/+$/g, ''),
            searchQuery: params.get('query') || '',
            statusFilter: statusFilter,
            currentPage: Math.floor(page),
            pageSize: pageSize,
            sortField: sortField,
            sortDirection: sortDirection
        };
    }

    private applyDriveState(state: any) {
        this.searchQuery = state.searchQuery || '';
        this.statusFilter = state.statusFilter || 'ALL';
        this.currentPage = Math.max(1, Number(state.currentPage || 1));
        this.pageSize = this.pageSizeOptions.indexOf(Number(state.pageSize)) >= 0
            ? Number(state.pageSize)
            : 10;
        this.sortField = state.sortField || 'name';
        this.sortDirection = state.sortDirection === 'desc' ? 'desc' : 'asc';
    }

    private currentFolderPath() {
        return this.currentFolder ? String(this.currentFolder.id || '') : '';
    }

    private rememberFolderView(path?: string) {
        let key = path !== undefined ? String(path || '') : this.currentFolderPath();
        this.folderViewStates[key] = {
            searchQuery: this.searchQuery,
            statusFilter: this.statusFilter,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            sortField: this.sortField,
            sortDirection: this.sortDirection
        };
    }

    private restoreFolderView(path: string) {
        let state = this.folderViewStates[String(path || '')];
        if (state) {
            this.applyDriveState(state);
            return;
        }
        this.searchQuery = '';
        this.statusFilter = 'ALL';
        this.currentPage = 1;
    }

    private syncDriveUrl(path: string, mode: string = 'replace') {
        if (mode === 'none') return;
        let url = new URL(window.location.href);
        let values: any = {
            path: path || '',
            page: this.currentPage > 1 ? String(this.currentPage) : '',
            page_size: this.pageSize !== 10 ? String(this.pageSize) : '',
            sort: this.sortField !== 'name' ? this.sortField : '',
            direction: this.sortDirection !== 'asc' ? this.sortDirection : '',
            query: this.searchQuery || '',
            ocr: this.statusFilter !== 'ALL' ? this.statusFilter : ''
        };
        Object.keys(values).forEach((key: string) => {
            if (values[key]) url.searchParams.set(key, values[key]);
            else url.searchParams.delete(key);
        });
        let nextUrl = url.pathname + url.search + url.hash;
        if (mode === 'push') {
            window.history.pushState({}, document.title, nextUrl);
        } else {
            window.history.replaceState({}, document.title, nextUrl);
        }
    }

    private async restoreDriveUrlState() {
        let state = this.driveUrlState();
        let snapshot = this.driveViewSnapshot();
        this.trashMode = false;
        this.trashItems = [];
        this.selectedTrashItems = [];
        this.applyDriveState(state);
        let parts = state.path.split('/').filter((part: string) => !!part);
        let cursor: string[] = [];
        this.breadcrumbs = parts.map((part: string) => {
            cursor.push(part);
            return { id: cursor.join('/'), name: part };
        });
        this.currentFolder = parts.length
            ? { id: state.path, name: parts[parts.length - 1] }
            : null;
        this.folders = [];
        this.assets = [];
        await this.load(state.path, snapshot, 'none');
    }

    public async loadTrash() {
        if (!this.canWrite()) return;
        this.loading = true;
        this.selectedTrashItems = [];
        await this.service.render();
        try {
            let result: any = await this.service.request.post(
                '/api/sources/storage/trash/list',
                { organization_id: this.selectedOrganizationId }
            );
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '원천 데이터 휴지통을 불러오지 못했습니다.'
                );
                return;
            }
            this.trashItems = result.data.items || [];
            this.trashRetentionDays = Number(result.data.retention_days || 30);
            this.trashCorruptBatchCount = Number(
                result.data.corrupt_batch_count || 0
            );
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public visibleTrashItems() {
        let query = String(this.trashQuery || '').trim().toLocaleLowerCase();
        if (!query) return this.trashItems;
        return this.trashItems.filter((item: any) => {
            return String(item.name || '').toLocaleLowerCase().includes(query)
                || String(item.original_location || '').toLocaleLowerCase().includes(query);
        });
    }

    public trashSelectionCount() {
        return this.selectedTrashItems.length;
    }

    public isTrashItemSelected(item: any) {
        return this.selectedTrashItems.some((selected: any) => {
            return selected.id === item.id;
        });
    }

    public async toggleTrashSelection(event: any, item: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!item.available) return;
        let index = this.selectedTrashItems.findIndex((selected: any) => {
            return selected.id === item.id;
        });
        if (index >= 0) this.selectedTrashItems.splice(index, 1);
        else this.selectedTrashItems.push(item);
        await this.service.render();
    }

    public allVisibleTrashSelected() {
        let items = this.visibleTrashItems().filter((item: any) => item.available);
        return items.length > 0 && items.every((item: any) => {
            return this.isTrashItemSelected(item);
        });
    }

    public someVisibleTrashSelected() {
        let items = this.visibleTrashItems().filter((item: any) => item.available);
        let count = items.filter((item: any) => {
            return this.isTrashItemSelected(item);
        }).length;
        return count > 0 && count < items.length;
    }

    public async toggleAllTrashSelection(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        let visible = this.visibleTrashItems().filter((item: any) => item.available);
        this.selectedTrashItems = this.allVisibleTrashSelected()
            ? []
            : visible.slice();
        await this.service.render();
    }

    public async clearTrashSelection() {
        this.selectedTrashItems = [];
        await this.service.render();
    }

    public trashReferences(items: any[]) {
        return items.map((item: any) => ({
            batch_id: item.batch_id,
            item_id: item.item_id
        }));
    }

    public trashLocationLabel(item: any) {
        return item.original_location || '원천 데이터 최상위';
    }

    public trashTypeLabel(item: any) {
        if (item.kind === 'folder') return '폴더';
        return item.file_count > 1
            ? '문서 · 연결 파일 ' + item.file_count + '개'
            : '문서';
    }

    public trashDaysRemaining(item: any) {
        let expiresAt = serviceTimestamp(item && item.expires_at);
        if (!Number.isFinite(expiresAt)) return 0;
        return Math.max(
            0,
            Math.ceil((expiresAt - Date.now()) / (24 * 60 * 60 * 1000))
        );
    }

    public trashExpiryLabel(item: any) {
        let days = this.trashDaysRemaining(item);
        return days === 0 ? 'D-Day' : 'D-' + days;
    }

    public trashExpiryState(item: any) {
        let days = this.trashDaysRemaining(item);
        if (days <= 3) return 'critical';
        if (days <= 7) return 'warning';
        return 'normal';
    }

    public async restoreSelectedTrashItems() {
        let items = this.selectedTrashItems.slice();
        if (this.trashBusy || !items.length) return;
        let confirmed = await this.service.modal.show({
            title: '원래 위치로 복원',
            message: items.length + '개 항목을 삭제 전 위치로 복원합니다.'
                + ' 같은 이름이 있으면 복원하지 않습니다. 계속하시겠습니까?',
            cancel: '취소',
            action: '복원',
            actionBtn: 'success',
            status: 'success'
        });
        if (!confirmed) return;
        this.trashBusy = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post(
                '/api/sources/storage/trash/restore',
                {
                    organization_id: this.selectedOrganizationId,
                    items_json: JSON.stringify(this.trashReferences(items))
                }
            );
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '선택한 항목을 복원하지 못했습니다.'
                );
                return;
            }
            await this.loadTrash();
            await this.service.modal.show({
                title: '복원 완료',
                message: String(result.data.restored_count || items.length)
                    + '개 항목을 원래 위치로 복원했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
        } finally {
            this.trashBusy = false;
            await this.service.render();
        }
    }

    public async permanentlyDeleteSelectedTrashItems() {
        let items = this.selectedTrashItems.slice();
        if (this.trashBusy || !items.length) return;
        let confirmed = await this.service.modal.show({
            title: '영구 삭제',
            message: items.length + '개 항목을 영구 삭제합니다.'
                + ' 이 작업은 되돌릴 수 없습니다. 계속하시겠습니까?',
            cancel: '취소',
            action: '영구 삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        await this.runTrashPermanentDelete(
            '/api/sources/storage/trash/delete',
            { items_json: JSON.stringify(this.trashReferences(items)) }
        );
    }

    public async emptyTrash() {
        if (this.trashBusy || !this.trashItems.length) return;
        let confirmed = await this.service.modal.show({
            title: '원천 데이터 휴지통 비우기',
            message: '휴지통의 모든 항목을 영구 삭제합니다.'
                + ' 이 작업은 되돌릴 수 없습니다. 계속하시겠습니까?',
            cancel: '취소',
            action: '모두 영구 삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        await this.runTrashPermanentDelete(
            '/api/sources/storage/trash/empty',
            {}
        );
    }

    private async runTrashPermanentDelete(endpoint: string, payload: any) {
        this.trashBusy = true;
        await this.service.render();
        try {
            payload.organization_id = this.selectedOrganizationId;
            let result: any = await this.service.request.post(endpoint, payload);
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '휴지통 항목을 영구 삭제하지 못했습니다.'
                );
                return;
            }
            await this.loadTrash();
            await this.service.modal.show({
                title: '영구 삭제 완료',
                message: String(result.data.permanently_deleted_count || 0)
                    + '개 항목을 영구 삭제했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
        } finally {
            this.trashBusy = false;
            await this.service.render();
        }
    }

    public async refreshCurrentView() {
        if (this.trashMode) await this.loadTrash();
        else await this.load();
    }

    public async openBreadcrumb(folder: any) {
        let index = this.breadcrumbs.findIndex((item: any) => {
            return item.id === folder.id;
        });
        let breadcrumbs = index >= 0
            ? this.breadcrumbs.slice(0, index + 1)
            : [{ id: folder.id, name: folder.name }];
        await this.navigateToFolder(folder.id, {
            id: folder.id,
            name: folder.name
        }, breadcrumbs);
    }

    public parentLocationName() {
        if (this.breadcrumbs.length <= 1) return '원천 데이터';
        return this.breadcrumbs[this.breadcrumbs.length - 2].name;
    }

    public parentFolderPath() {
        return this.breadcrumbs.length > 1
            ? this.breadcrumbs[this.breadcrumbs.length - 2].id
            : '';
    }

    public async openParentFolder() {
        if (!this.currentFolder) return;
        let parentId = this.breadcrumbs.length > 1
            ? this.breadcrumbs[this.breadcrumbs.length - 2].id
            : '';
        let breadcrumbs = this.breadcrumbs.slice(0, -1);
        let parent = breadcrumbs.length
            ? breadcrumbs[breadcrumbs.length - 1]
            : null;
        await this.navigateToFolder(parentId, parent, breadcrumbs);
    }

    private driveViewSnapshot() {
        return {
            currentFolder: this.currentFolder,
            breadcrumbs: this.breadcrumbs.slice(),
            folders: this.folders.slice(),
            assets: this.assets.slice(),
            totalFolderCount: this.totalFolderCount,
            totalDocumentCount: this.totalDocumentCount,
            statusCounts: Object.assign({}, this.statusCounts),
            searchQuery: this.searchQuery,
            statusFilter: this.statusFilter,
            currentPage: this.currentPage,
            selectedDriveItems: this.selectedDriveItems.slice(),
            lastSelectedDriveKey: this.lastSelectedDriveKey
        };
    }

    private restoreDriveView(snapshot: any) {
        this.currentFolder = snapshot.currentFolder;
        this.breadcrumbs = snapshot.breadcrumbs;
        this.folders = snapshot.folders;
        this.assets = snapshot.assets;
        this.totalFolderCount = snapshot.totalFolderCount;
        this.totalDocumentCount = snapshot.totalDocumentCount;
        this.statusCounts = snapshot.statusCounts;
        this.searchQuery = snapshot.searchQuery;
        this.statusFilter = snapshot.statusFilter;
        this.currentPage = snapshot.currentPage;
        this.selectedDriveItems = snapshot.selectedDriveItems;
        this.lastSelectedDriveKey = snapshot.lastSelectedDriveKey;
    }

    private folderNavigationBreadcrumbs(folder: any) {
        let currentId = this.currentFolder ? this.currentFolder.id : '';
        if (!this.searchQuery && String(folder.parent_id || '') === String(currentId)) {
            return this.breadcrumbs.concat([{
                id: folder.id,
                name: folder.name
            }]);
        }
        if (this.storageMode) {
            let parts = String(folder.id || '').split('/').filter((part: string) => !!part);
            let current: string[] = [];
            return parts.map((part: string, index: number) => {
                current.push(part);
                return {
                    id: current.join('/'),
                    name: index === parts.length - 1 ? folder.name : part
                };
            });
        }
        return this.breadcrumbs.concat([{
            id: folder.id,
            name: folder.name
        }]);
    }

    private async navigateToFolder(
        folderId: string,
        folder: any,
        breadcrumbs: any[]
    ) {
        if (this.loading) return;
        let snapshot = this.driveViewSnapshot();
        this.rememberFolderView();
        this.cancelUpload();
        this.restoreFolderView(folderId);
        this.currentFolder = folder;
        this.breadcrumbs = breadcrumbs;
        this.folders = [];
        this.assets = [];
        this.totalFolderCount = 0;
        this.totalDocumentCount = 0;
        this.statusCounts = {};
        this.loading = true;
        await this.service.render();
        await this.load(folderId, snapshot, 'push');
    }

    public visibleBreadcrumbs() {
        if (this.breadcrumbs.length <= 3) return this.breadcrumbs;
        return this.breadcrumbs.slice(-2);
    }

    public hiddenBreadcrumbsLabel() {
        if (this.breadcrumbs.length <= 3) return '';
        return this.breadcrumbs
            .slice(0, -2)
            .map((folder: any) => folder.name)
            .join(' / ');
    }

    public isCurrentBreadcrumb(folder: any) {
        if (!folder || !this.breadcrumbs.length) return false;
        return this.breadcrumbs[this.breadcrumbs.length - 1].id === folder.id;
    }

    public currentLocationName() {
        return this.currentFolder ? this.currentFolder.name : '전체 원천 데이터';
    }

    public async openContextMenu(event: any, kind: string, item?: any) {
        event.preventDefault();
        event.stopPropagation();
        this.showCreateMenu = false;
        let menuWidth = 224;
        let menuHeight = kind === 'blank' ? 150 : 190;
        if (this.selectionCount() > 0 && kind !== 'blank' && !this.isDriveItemSelected(kind, item)) {
            this.selectedDriveItems = [{ kind: kind, item: item }];
            this.lastSelectedDriveKey = this.driveItemKey(kind, item);
        }
        this.contextMenu = {
            visible: true,
            x: Math.max(8, Math.min(event.clientX, window.innerWidth - menuWidth - 8)),
            y: Math.max(8, Math.min(event.clientY, window.innerHeight - menuHeight - 8)),
            kind: kind,
            label: item ? (item.name || item.title || '') : this.currentLocationName(),
            item: item || null
        };
        await this.service.render();
    }

    public async closeContextMenu() {
        if (!this.contextMenu.visible) return;
        this.contextMenu.visible = false;
        await this.service.render();
    }

    public async closePageMenus() {
        let changed = this.contextMenu.visible || this.showCreateMenu;
        this.contextMenu.visible = false;
        this.showCreateMenu = false;
        if (changed) await this.service.render();
    }

    public async openContextItem(event: any) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.contextMenu.item || this.contextMenu.kind !== 'folder') return;
        let item = this.contextMenu.item;
        this.contextMenu.visible = false;
        await this.openFolder(item);
    }

    public async startRename(event: any) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.contextMenu.item || !this.canWrite()) return;
        this.renameTarget = {
            kind: this.contextMenu.kind,
            item: this.contextMenu.item
        };
        this.renameName = this.contextMenu.label;
        this.contextMenu.visible = false;
        await this.service.render();
    }

    public async cancelRename() {
        if (this.renaming) return;
        this.renameTarget = null;
        this.renameName = '';
        await this.service.render();
    }

    public async renameStorageItem() {
        if (this.renaming || !this.renameTarget) return;
        let name = (this.renameName || '').trim();
        if (!name) {
            await this.showError('변경할 이름을 입력해 주세요.');
            return;
        }
        let kind = this.renameTarget.kind;
        let item = this.renameTarget.item;
        let endpoint = kind === 'folder'
            ? '/api/sources/storage/folders/rename'
            : '/api/sources/storage/documents/rename';
        let payload: any = {
            organization_id: this.selectedOrganizationId,
            name: name
        };
        if (kind === 'folder') payload.path = item.id;
        else {
            payload.path = item.folder_id || '';
            payload.document_key = item.storage_key || item.title;
        }
        this.renaming = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post(endpoint, payload);
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '이름을 변경하지 못했습니다.'
                );
                return;
            }
            this.renameTarget = null;
            this.renameName = '';
            await this.load();
        } finally {
            this.renaming = false;
            await this.service.render();
        }
    }

    public storageDeleteItem(entry: any) {
        let kind = entry.kind;
        let item = entry.item;
        if (kind === 'folder') {
            return {
                kind: 'folder',
                path: item.id,
                name: item.name
            };
        }
        return {
            kind: 'document',
            path: item.folder_id || '',
            document_key: item.storage_key || item.title,
            name: item.title
        };
    }

    public storageMoveItem(entry: any) {
        return this.storageDeleteItem(entry);
    }

    private pathIsWithin(path: string, parent: string) {
        let normalizedPath = String(path || '').replace(/^\/+|\/+$/g, '');
        let normalizedParent = String(parent || '').replace(/^\/+|\/+$/g, '');
        if (!normalizedParent) return true;
        return normalizedPath === normalizedParent
            || normalizedPath.startsWith(normalizedParent + '/');
    }

    private normalizedMoveEntries(entries: any[]) {
        let folderPaths = entries
            .filter((entry: any) => entry.kind === 'folder')
            .map((entry: any) => String(entry.item && entry.item.id || ''));
        return entries.filter((entry: any) => {
            if (entry.kind === 'folder') {
                let path = String(entry.item && entry.item.id || '');
                return !folderPaths.some((parent: string) => {
                    return parent !== path && this.pathIsWithin(path, parent);
                });
            }
            let folder = String(entry.item && entry.item.folder_id || '');
            return !folderPaths.some((parent: string) => {
                return this.pathIsWithin(folder, parent);
            });
        });
    }

    private isInternalDriveDrag(event?: any) {
        if (this.draggingDriveItems.length) return true;
        let types = event && event.dataTransfer
            ? Array.from(event.dataTransfer.types || [])
            : [];
        return types.indexOf(this.internalDragType) >= 0;
    }

    public isDraggingDriveItem(kind: string, item: any) {
        return this.draggingDriveItems.some((entry: any) => {
            return entry.kind === kind
                && entry.item
                && entry.item.id === item.id;
        });
    }

    public canDropIntoFolderPath(destinationPath: string) {
        if (
            !this.canWrite()
            || !this.storageMode
            || this.trashMode
            || this.moving
        ) return false;
        let entries = this.normalizedMoveEntries(this.draggingDriveItems);
        if (!entries.length) return false;
        let target = String(destinationPath || '').replace(/^\/+|\/+$/g, '');
        return entries.every((entry: any) => {
            let parent = entry.kind === 'folder'
                ? String(entry.item && entry.item.parent_id || '')
                : String(entry.item && entry.item.folder_id || '');
            if (parent === target) return false;
            if (entry.kind !== 'folder') return true;
            let source = String(entry.item && entry.item.id || '');
            return source !== target && !this.pathIsWithin(target, source);
        });
    }

    public driveDragEntries(kind: string, item: any) {
        let entry = { kind: kind, item: item };
        let entries = this.isDriveItemSelected(kind, item)
            ? this.selectedDriveItems.slice()
            : [entry];
        return this.normalizedMoveEntries(entries);
    }

    private removeDriveDragPreview() {
        if (
            this.driveDragPreviewElement
            && this.driveDragPreviewElement.parentNode
        ) {
            this.driveDragPreviewElement.parentNode.removeChild(
                this.driveDragPreviewElement
            );
        }
        this.driveDragPreviewElement = null;
    }

    private createDriveDragPreview(entries: any[]) {
        this.removeDriveDragPreview();
        let preview = document.createElement('div');
        preview.setAttribute('aria-hidden', 'true');
        preview.style.cssText = [
            'position:fixed',
            'top:-1000px',
            'left:-1000px',
            'z-index:9999',
            'width:236px',
            'height:52px',
            'display:flex',
            'align-items:center',
            'box-sizing:border-box',
            'padding:7px 9px',
            'border:1px solid rgba(190,207,200,.9)',
            'border-radius:11px',
            'color:#30463d',
            'background:rgba(255,255,255,.96)',
            'box-shadow:0 8px 20px rgba(24,45,37,.2)',
            'font-family:Arial,sans-serif',
            'gap:9px'
        ].join(';');

        let stack = document.createElement('div');
        stack.style.cssText = [
            'position:relative',
            'width:42px',
            'height:34px',
            'flex:0 0 42px'
        ].join(';');
        entries.slice(0, 3).reverse().forEach((entry: any, index: number) => {
            let originalIndex = Math.min(entries.length, 3) - index - 1;
            let icon = document.createElement('span');
            icon.textContent = entry.kind === 'folder'
                ? 'DIR'
                : (this.assetExtension(entry.item) || 'DOC');
            icon.style.cssText = [
                'position:absolute',
                'top:0',
                'left:' + (originalIndex * 6) + 'px',
                'width:27px',
                'height:32px',
                'display:grid',
                'box-sizing:border-box',
                'border:1px solid #bcd3ca',
                'border-radius:6px',
                'place-items:center',
                'color:#267157',
                'background:#edf6f2',
                'box-shadow:0 1px 3px rgba(30,51,43,.12)',
                'font-size:7px',
                'font-weight:800'
            ].join(';');
            stack.appendChild(icon);
        });
        preview.appendChild(stack);

        let copy = document.createElement('div');
        copy.style.cssText = 'min-width:0;flex:1 1 auto';
        let name = document.createElement('strong');
        name.textContent = entries[0].item.name
            || entries[0].item.title
            || '이름 없음';
        name.style.cssText = [
            'display:block',
            'overflow:hidden',
            'color:#344940',
            'font-size:10px',
            'font-weight:700',
            'text-overflow:ellipsis',
            'white-space:nowrap'
        ].join(';');
        let detail = document.createElement('small');
        detail.textContent = entries.length > 1
            ? '외 ' + (entries.length - 1) + '개 함께 이동'
            : '이동';
        detail.style.cssText = [
            'display:block',
            'margin-top:3px',
            'color:#7a8983',
            'font-size:8px'
        ].join(';');
        copy.appendChild(name);
        copy.appendChild(detail);
        preview.appendChild(copy);

        let count = document.createElement('strong');
        count.textContent = String(entries.length);
        count.style.cssText = [
            'min-width:25px',
            'height:25px',
            'display:grid',
            'border-radius:999px',
            'place-items:center',
            'color:#fff',
            'background:#26785b',
            'font-size:9px'
        ].join(';');
        preview.appendChild(count);
        document.body.appendChild(preview);
        this.driveDragPreviewElement = preview;
        return preview;
    }

    public async onDriveDragStart(event: any, kind: string, item: any) {
        if (!this.canWrite() || !this.storageMode || this.trashMode || this.moving) {
            event.preventDefault();
            return;
        }
        this.draggingDriveItems = this.driveDragEntries(kind, item);
        this.dragOverFolderId = null;
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData(
            this.internalDragType,
            String(this.draggingDriveItems.length)
        );
        event.dataTransfer.setData(
            'text/plain',
            this.draggingDriveItems.map((selected: any) => {
                return selected.item.name || selected.item.title || '';
            }).join(', ')
        );
        let dragPreview = this.createDriveDragPreview(
            this.draggingDriveItems
        );
        event.dataTransfer.setDragImage(dragPreview, 24, 24);
        await this.service.render();
    }

    public async onDriveDragEnd() {
        this.removeDriveDragPreview();
        this.draggingDriveItems = [];
        this.dragOverFolderId = null;
        await this.service.render();
    }

    public onMoveTargetDragOver(event: any, destinationPath: string) {
        if (!this.isInternalDriveDrag(event)) return;
        event.preventDefault();
        event.stopPropagation();
        let allowed = this.canDropIntoFolderPath(destinationPath);
        event.dataTransfer.dropEffect = allowed ? 'move' : 'none';
        let nextTarget = allowed ? String(destinationPath || '') : null;
        if (this.dragOverFolderId !== nextTarget) {
            this.dragOverFolderId = nextTarget;
            this.service.render();
        }
    }

    public onMoveTargetDragLeave(event: any, destinationPath: string) {
        if (!this.isInternalDriveDrag(event)) return;
        if (
            event.currentTarget
            && event.relatedTarget
            && event.currentTarget.contains(event.relatedTarget)
        ) return;
        if (this.dragOverFolderId === String(destinationPath || '')) {
            this.dragOverFolderId = null;
            this.service.render();
        }
    }

    public async onMoveTargetDrop(event: any, destinationPath: string) {
        if (!this.isInternalDriveDrag(event)) return;
        event.preventDefault();
        event.stopPropagation();
        let allowed = this.canDropIntoFolderPath(destinationPath);
        let entries = this.normalizedMoveEntries(this.draggingDriveItems);
        this.removeDriveDragPreview();
        this.draggingDriveItems = [];
        this.dragOverFolderId = null;
        await this.service.render();
        if (!allowed || !entries.length) return;
        await this.moveStorageItems(entries, destinationPath);
    }

    public async moveStorageItems(entries: any[], destinationPath: string) {
        if (this.moving || !this.canWrite() || !entries.length) return;
        this.moving = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post(
                '/api/sources/storage/items/move',
                {
                    organization_id: this.selectedOrganizationId,
                    destination_path: destinationPath || '',
                    items_json: JSON.stringify(
                        entries.map((entry: any) => this.storageMoveItem(entry))
                    )
                }
            );
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '선택한 항목을 이동하지 못했습니다.'
                );
                return;
            }
            await this.load();
        } finally {
            this.moving = false;
            await this.service.render();
        }
    }

    public async deleteSelectedItems() {
        await this.deleteStorageItems(this.selectedDriveItems.slice());
    }

    public async deleteContextItem(event: any) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.contextMenu.item || !this.canWrite()) return;
        let contextEntry = {
            kind: this.contextMenu.kind,
            item: this.contextMenu.item
        };
        let entries = this.isDriveItemSelected(
            contextEntry.kind,
            contextEntry.item
        )
            ? this.selectedDriveItems.slice()
            : [contextEntry];
        this.contextMenu.visible = false;
        await this.service.render();
        await this.deleteStorageItems(entries);
    }

    public async deleteStorageItems(entries: any[]) {
        if (this.deleting || !this.canWrite() || !entries.length) return;
        let folderCount = entries.filter((entry: any) => {
            return entry.kind === 'folder';
        }).length;
        let documentCount = entries.length - folderCount;
        let summary = [
            folderCount ? '폴더 ' + folderCount + '개' : '',
            documentCount ? '문서 ' + documentCount + '개' : ''
        ].filter((value: string) => !!value).join(', ');
        let confirmed = await this.service.modal.show({
            title: '선택 항목 삭제',
            message: summary + '를 서버 휴지통으로 이동합니다.'
                + (folderCount ? ' 폴더 안의 모든 하위 항목도 함께 이동됩니다.' : '')
                + ' 계속하시겠습니까?',
            cancel: '취소',
            action: '이동',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;

        this.deleting = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post(
                '/api/sources/storage/items/delete',
                {
                    organization_id: this.selectedOrganizationId,
                    items_json: JSON.stringify(
                        entries.map((entry: any) => this.storageDeleteItem(entry))
                    )
                }
            );
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '선택한 항목을 삭제하지 못했습니다.'
                );
                return;
            }
            await this.load();
            await this.service.modal.show({
                title: '휴지통으로 이동 완료',
                message: String(result.data.deleted_count || entries.length)
                    + '개 항목을 서버 휴지통으로 이동했습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
        } finally {
            this.deleting = false;
            await this.service.render();
        }
    }

    public isDriveItemSelected(kind: string, item: any) {
        return this.selectedDriveItems.some((selected: any) => {
            return selected.kind === kind && selected.item && selected.item.id === item.id;
        });
    }

    public selectionCount() {
        return this.selectedDriveItems.length;
    }

    public driveItemKey(kind: string, item: any) {
        return kind + ':' + String(item && item.id || '');
    }

    public async clearDriveSelection() {
        this.selectedDriveItems = [];
        this.lastSelectedDriveKey = '';
        this.showCreateMenu = false;
        await this.service.render();
    }

    public selectDriveRange(kind: string, item: any) {
        let items = this.visibleDriveItems();
        let targetKey = this.driveItemKey(kind, item);
        let targetIndex = items.findIndex((entry: any) => {
            return this.driveItemKey(entry.kind, entry.item) === targetKey;
        });
        let anchorIndex = items.findIndex((entry: any) => {
            return this.driveItemKey(entry.kind, entry.item) === this.lastSelectedDriveKey;
        });
        if (targetIndex < 0 || anchorIndex < 0) {
            if (!this.isDriveItemSelected(kind, item)) {
                this.selectedDriveItems.push({ kind: kind, item: item });
            }
            this.lastSelectedDriveKey = targetKey;
            return;
        }
        let start = Math.min(anchorIndex, targetIndex);
        let end = Math.max(anchorIndex, targetIndex);
        items.slice(start, end + 1).forEach((entry: any) => {
            if (!this.isDriveItemSelected(entry.kind, entry.item)) {
                this.selectedDriveItems.push(entry);
            }
        });
        this.lastSelectedDriveKey = targetKey;
    }

    public async toggleDriveSelection(event: any, kind: string, item: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (event && event.shiftKey && this.lastSelectedDriveKey) {
            this.selectDriveRange(kind, item);
            await this.service.render();
            return;
        }
        let index = this.selectedDriveItems.findIndex((selected: any) => {
            return selected.kind === kind && selected.item && selected.item.id === item.id;
        });
        if (index >= 0) this.selectedDriveItems.splice(index, 1);
        else this.selectedDriveItems.push({ kind: kind, item: item });
        if (index < 0) this.lastSelectedDriveKey = this.driveItemKey(kind, item);
        else if (this.lastSelectedDriveKey === this.driveItemKey(kind, item)) {
            let last = this.selectedDriveItems[this.selectedDriveItems.length - 1];
            this.lastSelectedDriveKey = last
                ? this.driveItemKey(last.kind, last.item)
                : '';
        }
        await this.service.render();
    }

    public visibleDriveItems() {
        return this.visibleFolders().map((item: any) => ({ kind: 'folder', item: item }))
            .concat(this.visibleAssets().map((item: any) => ({ kind: 'file', item: item })));
    }

    public allVisibleSelected() {
        let items = this.visibleDriveItems();
        return items.length > 0 && items.every((entry: any) => {
            return this.isDriveItemSelected(entry.kind, entry.item);
        });
    }

    public someVisibleSelected() {
        let count = this.visibleDriveItems().filter((entry: any) => {
            return this.isDriveItemSelected(entry.kind, entry.item);
        }).length;
        return count > 0 && count < this.visibleDriveItems().length;
    }

    public async toggleAllSelection(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.selectedDriveItems = this.allVisibleSelected() ? [] : this.visibleDriveItems();
        let last = this.selectedDriveItems[this.selectedDriveItems.length - 1];
        this.lastSelectedDriveKey = last
            ? this.driveItemKey(last.kind, last.item)
            : '';
        await this.service.render();
    }

    public async activateDriveItem(event: any, kind: string, item: any) {
        if (event && event.shiftKey) {
            event.preventDefault();
            this.selectDriveRange(kind, item);
            await this.service.render();
            return;
        }
        if (event && (event.ctrlKey || event.metaKey)) {
            await this.toggleDriveSelection(event, kind, item);
            return;
        }
        if (kind === 'folder') await this.openFolder(item);
    }

    public async previewDriveDocument(event: any, asset: any) {
        event.preventDefault();
        event.stopPropagation();
        await this.openDocumentPreview(asset);
    }

    public folderItemCount(folder: any) {
        return Number(folder.folder_count || 0) + Number(folder.asset_count || 0);
    }

    public folderPathMeta(folder: any) {
        if (this.searchQuery && folder.parent_id) return folder.parent_id;
        return this.folderItemCount(folder) + '개 항목';
    }

    public clearFilters() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
            this.searchTimer = null;
        }
        this.searchQuery = '';
        this.statusFilter = 'ALL';
        this.currentPage = 1;
    }

    public scheduleSearch() {
        if (this.searchTimer) window.clearTimeout(this.searchTimer);
        this.currentPage = 1;
        this.searchTimer = window.setTimeout(async () => {
            this.searchTimer = null;
            await this.load();
        }, 250);
    }

    public async clearSearch() {
        this.searchQuery = '';
        this.currentPage = 1;
        await this.load();
    }

    public async setStatusFilter(status: string) {
        if (this.statusFilter === status) return;
        this.statusFilter = status;
        this.currentPage = 1;
        await this.load();
    }

    public async resetFilters() {
        this.clearFilters();
        await this.load();
    }

    public visibleFolders() {
        return this.folders;
    }

    public visibleAssets() {
        return this.assets;
    }

    public totalItemCount() {
        return this.totalFolderCount + this.totalDocumentCount;
    }

    public totalPageCount() {
        return Math.max(1, Math.ceil(this.totalItemCount() / this.pageSize));
    }

    public pageStartItem() {
        if (!this.totalItemCount()) return 0;
        return (this.currentPage - 1) * this.pageSize + 1;
    }

    public pageEndItem() {
        return Math.min(this.currentPage * this.pageSize, this.totalItemCount());
    }

    public paginationItems() {
        let total = this.totalPageCount();
        if (total <= 7) {
            return Array.from({ length: total }, (_: any, index: number) => ({
                type: 'page',
                value: index + 1
            }));
        }
        let pages: any[] = [{ type: 'page', value: 1 }];
        let start = Math.max(2, this.currentPage - 1);
        let end = Math.min(total - 1, this.currentPage + 1);
        if (start > 2) pages.push({ type: 'ellipsis', value: 'start' });
        for (let page = start; page <= end; page += 1) {
            pages.push({ type: 'page', value: page });
        }
        if (end < total - 1) pages.push({ type: 'ellipsis', value: 'end' });
        pages.push({ type: 'page', value: total });
        return pages;
    }

    public async goToPage(page: number) {
        let target = Math.max(1, Math.min(Number(page), this.totalPageCount()));
        if (target === this.currentPage || this.loading) return;
        this.currentPage = target;
        await this.load();
    }

    public async changePageSize(value: any) {
        let size = Number(value);
        if (this.pageSizeOptions.indexOf(size) < 0 || size === this.pageSize) return;
        this.pageSize = size;
        this.currentPage = 1;
        await this.load();
    }

    public async changeSort(field: string) {
        if (this.sortField === field) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDirection = 'asc';
        }
        this.currentPage = 1;
        await this.load();
    }

    public sortAriaSort(field: string) {
        if (this.sortField !== field) return 'none';
        return this.sortDirection === 'asc' ? 'ascending' : 'descending';
    }

    public sortAriaLabel(field: string, label: string) {
        if (this.sortField !== field) return label + ' 오름차순 정렬';
        return label + (this.sortDirection === 'asc'
            ? ' 내림차순 정렬'
            : ' 오름차순 정렬');
    }

    public statusCount(status: string) {
        return Number(this.statusCounts[status] || 0);
    }

    public assetStatus(asset: any) {
        let version = asset && asset.latest_version;
        if (this.storageMode) {
            if (this.assetHasOcr(asset)) return 'READY';
            if (version && version.status === 'FAILED') return 'FAILED';
            return 'PROCESSING';
        }
        let job = version && version.latest_extraction;
        if (job && job.status === 'SUCCEEDED') return 'READY';
        if (job && job.status === 'FAILED') return 'FAILED';
        if (job && (job.status === 'RUNNING' || job.status === 'PENDING')) {
            return 'PROCESSING';
        }
        if (version && version.status === 'READY') return 'READY';
        if (version && version.status === 'EXTRACTION_FAILED') return 'FAILED';
        if (version && version.metadata && !version.metadata.extractable) {
            return 'FAILED';
        }
        return 'PROCESSING';
    }

    public assetExtension(asset: any) {
        return this.assetOriginalExtension(asset) || 'DOC';
    }

    public assetOriginalFile(asset: any) {
        let files = asset && asset.storage_files || [];
        return files.find((item: any) => item.role === 'ORIGINAL')
            || files.find((item: any) => item.role === 'METADATA')
            || null;
    }

    public assetOriginalExtension(asset: any) {
        let original = this.assetOriginalFile(asset);
        if (original) {
            return String(original.extension || '').replace('.', '').toUpperCase();
        }
        if (!this.storageMode) {
            let extension = asset && asset.latest_version
                && asset.latest_version.metadata
                && asset.latest_version.metadata.extension || '';
            return String(extension).replace('.', '').toUpperCase();
        }
        return '';
    }

    public assetOriginalFileName(asset: any) {
        let original = this.assetOriginalFile(asset);
        return original ? original.name : '원본 파일 없음';
    }

    public assetOcrFile(asset: any) {
        return (asset && asset.storage_files || []).find((item: any) => {
            return item.role === 'OCR';
        }) || null;
    }

    public assetHasOcr(asset: any) {
        return !!this.assetOcrFile(asset);
    }

    public assetOcrIsActive(asset: any) {
        let version = asset && asset.latest_version;
        let job = version && version.latest_extraction;
        return !!job && (job.status === 'RUNNING' || job.status === 'PENDING');
    }

    public assetOcrJob(asset: any) {
        let version = asset && asset.latest_version;
        return version && version.latest_extraction || null;
    }

    public assetOcrJobStatus(asset: any) {
        let job = this.assetOcrJob(asset);
        return String(job && job.job_status || '').toUpperCase();
    }

    public assetOcrCanRetry(asset: any) {
        return ['FAILED', 'SUBMIT_UNKNOWN', 'CANCELLED'].includes(
            this.assetOcrJobStatus(asset)
        );
    }

    public assetOcrCanCancel(asset: any) {
        return ['QUEUED', 'RETRY_WAIT', 'SUBMITTED'].includes(
            this.assetOcrJobStatus(asset)
        );
    }

    public assetOcrHasError(asset: any) {
        let job = this.assetOcrJob(asset);
        return !!job && !!(job.error_code || job.error_message);
    }

    public assetOcrLabel(asset: any) {
        let version = asset && asset.latest_version;
        let job = version && version.latest_extraction;
        if (job && job.error_code === 'OCR_POSTPROCESS_FAILED') {
            return '후처리 실패';
        }
        let postprocessStatus = String(
            job && job.metrics && job.metrics.postprocess_status || ''
        ).toUpperCase();
        if (this.assetHasOcr(asset) && postprocessStatus === 'SUCCEEDED') {
            return 'QA 준비 완료';
        }
        if (this.assetHasOcr(asset)) return 'OCR 완료';
        if (!job) return 'OCR 미완료';
        let jobStatus = String(job.job_status || '').toUpperCase();
        if (jobStatus === 'CANCEL_REQUESTED') return 'OCR 취소 요청 중';
        if (jobStatus === 'CANCELLED') return 'OCR 취소됨';
        if (job.status === 'FAILED') return 'OCR 실패';
        let providerStatus = String(
            job.metrics && job.metrics.provider_status || ''
        ).toLowerCase();
        if (jobStatus === 'RETRY_WAIT') return 'OCR 재시도 대기';
        if (jobStatus === 'QUEUED') return 'OCR 대기 중';
        if (jobStatus === 'PREPARING') return 'PDF 분석 중';
        if (jobStatus === 'SUBMITTING') return 'OCR 요청 준비 중';
        if (providerStatus === 'validating') return 'OCR 요청 확인 중';
        if (providerStatus === 'direct_fallback') return '실패 페이지 복구 중';
        if (providerStatus === 'finalizing' || providerStatus === 'completed') {
            return '결과 정리 중';
        }
        if (['failed', 'expired', 'cancelled'].includes(providerStatus)) {
            return 'OCR 처리 실패';
        }
        let progress = this.assetOcrProgress(asset);
        if (progress) {
            return 'OCR 처리 ' + progress.processed + '/' + progress.total
                + ' · ' + progress.percent + '%';
        }
        if (job.status === 'RUNNING') return 'OCR 처리 중';
        return 'OCR 대기 중';
    }

    public ocrJobStageDescription(asset: any) {
        let job = this.assetOcrJob(asset);
        let status = this.assetOcrJobStatus(asset);
        if (!job) return '등록된 OCR 작업이 없습니다.';
        if (job.error_code === 'OCR_POSTPROCESS_FAILED') {
            return 'OCR 원시 결과는 보존됐지만 Text Unit 생성에 실패했습니다.';
        }
        if (String(job.metrics && job.metrics.postprocess_status || '').toUpperCase() === 'SUCCEEDED') {
            return 'OCR 후처리와 Text Unit 생성이 완료되었습니다.';
        }
        if (status === 'CANCELLED') return '사용자가 작업을 취소했습니다.';
        if (status === 'CANCEL_REQUESTED') return 'OpenAI Batch 취소를 요청하고 있습니다.';
        if (this.assetOcrCanRetry(asset)) return '오류 내용을 확인한 뒤 다시 시도할 수 있습니다.';
        if (String(job.metrics && job.metrics.provider_status || '').toLowerCase() === 'direct_fallback') {
            return 'Batch에서 실패한 페이지만 같은 Terra 계약으로 복구하고 있습니다.';
        }
        let progress = this.assetOcrProgress(asset);
        if (progress) {
            return '전체 ' + progress.total + '개 페이지 중 '
                + progress.processed + '개를 처리했습니다.';
        }
        return this.assetOcrLabel(asset);
    }

    public async openOcrManager(event: any, asset: any) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.assetOcrJob(asset)) return;
        this.ocrManagerAsset = asset;
        await this.service.render();
    }

    public async closeOcrManager() {
        if (this.ocrActionBusy) return;
        this.ocrManagerAsset = null;
        await this.service.render();
    }

    public async retryOcrJob() {
        let asset = this.ocrManagerAsset;
        let job = this.assetOcrJob(asset);
        if (this.ocrActionBusy || !job || !this.assetOcrCanRetry(asset)) return;
        let confirmed = await this.service.modal.show({
            title: 'OCR 다시 시도',
            message: '실패한 OCR 청크와 시도 횟수를 초기화하고 새 Batch로 다시 처리합니다. 다시 시도하시겠습니까?',
            cancel: '취소',
            action: '다시 시도',
            actionBtn: 'success',
            status: 'success'
        });
        if (!confirmed) return;
        this.ocrActionBusy = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post(
                '/api/sources/storage/ocr/retry',
                {
                    organization_id: this.selectedOrganizationId,
                    job_id: job.id
                }
            );
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : 'OCR 작업을 다시 시작하지 못했습니다.'
                );
                return;
            }
            this.ocrManagerAsset = null;
            await this.load();
        } finally {
            this.ocrActionBusy = false;
            await this.service.render();
        }
    }

    public async cancelOcrJob() {
        let asset = this.ocrManagerAsset;
        let job = this.assetOcrJob(asset);
        if (this.ocrActionBusy || !job || !this.assetOcrCanCancel(asset)) return;
        let confirmed = await this.service.modal.show({
            title: 'OCR 작업 취소',
            message: '대기 또는 처리 중인 OCR을 취소합니다. 이미 사용된 API 비용은 되돌릴 수 없습니다. 계속하시겠습니까?',
            cancel: '닫기',
            action: 'OCR 취소',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        this.ocrActionBusy = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post(
                '/api/sources/storage/ocr/cancel',
                {
                    organization_id: this.selectedOrganizationId,
                    job_id: job.id
                }
            );
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : 'OCR 작업을 취소하지 못했습니다.'
                );
                return;
            }
            this.ocrManagerAsset = null;
            await this.load();
        } finally {
            this.ocrActionBusy = false;
            await this.service.render();
        }
    }

    public assetOcrProgress(asset: any) {
        if (this.assetHasOcr(asset)) return null;
        let version = asset && asset.latest_version;
        let job = version && version.latest_extraction;
        if (!job || job.status !== 'RUNNING') return null;
        let metrics = job.metrics || {};
        let total = Math.max(0, Number(metrics.total_requests || 0));
        if (!total) return null;
        let completed = Math.max(0, Number(metrics.completed_requests || 0));
        let failed = Math.max(0, Number(metrics.failed_requests || 0));
        let processed = Math.min(total, completed + failed);
        return {
            total,
            completed,
            failed,
            processed,
            percent: Math.min(100, Math.round(processed / total * 100)),
        };
    }

    public assetOcrStatusTitle(asset: any) {
        let progress = this.assetOcrProgress(asset);
        if (!progress) return this.assetOcrLabel(asset);
        let detail = '전체 ' + progress.total + '개 묶음 · 완료 '
            + progress.completed + ' · 실패 ' + progress.failed;
        return this.assetOcrLabel(asset) + ' (' + detail + ')';
    }

    public assetOcrFileName(asset: any) {
        let ocr = this.assetOcrFile(asset);
        return ocr ? ocr.name : '';
    }

    public assetFileMeta(asset: any) {
        let location = this.searchQuery && asset.folder_id
            ? asset.folder_id + ' · '
            : '';
        if (asset.storage_files && asset.storage_files.length) {
            let extension = this.assetOriginalExtension(asset);
            let original = extension ? '원본 ' + extension : '원본 없음';
            return location + original;
        }
        let versionCount = (asset.versions || []).length;
        return location + this.assetExtension(asset) + ' · 버전 ' + versionCount + '개';
    }

    public previewVariants(asset: any) {
        let supportedRoles = ['ORIGINAL', 'METADATA', 'OCR'];
        return (asset && asset.storage_files || []).filter((item: any) => {
            let extension = String(item.extension || '').toLowerCase();
            return supportedRoles.indexOf(item.role) >= 0
                && ['.pdf', '.json', '.md'].indexOf(extension) >= 0;
        }).sort((left: any, right: any) => {
            let order: any = { ORIGINAL: 0, METADATA: 1, OCR: 2 };
            return Number(order[left.role] || 0) - Number(order[right.role] || 0);
        });
    }

    public previewFileLabel(file: any) {
        if (!file) return '';
        if (file.role === 'OCR') return 'OCR';
        let extension = String(file.extension || '').replace('.', '').toUpperCase();
        if (file.role === 'METADATA') return '원본 JSON';
        return '원본 ' + (extension || '문서');
    }

    public async openDocumentPreview(asset: any) {
        this.previewAsset = asset;
        this.previewFiles = this.previewVariants(asset);
        this.previewFile = null;
        this.previewContent = '';
        this.previewError = '';
        this.previewTruncated = false;
        this.previewUrl = null;
        if (!this.previewFiles.length) {
            this.previewMode = 'empty';
            await this.service.render();
            return;
        }
        await this.selectPreviewFile(this.previewFiles[0]);
    }

    public async selectPreviewFile(file: any) {
        if (!this.previewAsset || !file) return;
        let requestId = ++this.previewRequestId;
        this.previewFile = file;
        this.previewMode = 'loading';
        this.previewContent = '';
        this.previewError = '';
        this.previewTruncated = false;
        this.previewUrl = null;
        await this.service.render();

        let payload = {
            organization_id: this.selectedOrganizationId,
            path: this.previewAsset.folder_id || '',
            document_key: this.previewAsset.storage_key || this.previewAsset.title || '',
            filename: file.name || ''
        };
        let extension = String(file.extension || '').toLowerCase();
        if (extension === '.pdf') {
            let params = new URLSearchParams();
            Object.keys(payload).forEach((key: string) => {
                params.set(key, String((payload as any)[key] || ''));
            });
            if (requestId !== this.previewRequestId) return;
            this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                '/api/sources/storage/preview/file?' + params.toString()
            );
            this.previewMode = 'pdf';
            await this.service.render();
            return;
        }

        try {
            let result: any = await this.service.request.post(
                '/api/sources/storage/preview/text',
                payload
            );
            if (requestId !== this.previewRequestId) return;
            if (!result || result.code !== 200) {
                this.previewMode = 'error';
                this.previewError = result && result.data && result.data.message
                    ? result.data.message
                    : '문서 내용을 불러오지 못했습니다.';
            } else {
                let preview = result.data && result.data.preview || {};
                this.previewContent = preview.content || '';
                this.previewTruncated = !!preview.truncated;
                this.previewMode = 'text';
            }
        } catch (error) {
            if (requestId !== this.previewRequestId) return;
            this.previewMode = 'error';
            this.previewError = '문서 내용을 불러오지 못했습니다.';
        }
        await this.service.render();
    }

    public async closeDocumentPreview(event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.resetDocumentPreview();
        await this.service.render();
    }

    private resetDocumentPreview() {
        this.previewRequestId += 1;
        this.previewAsset = null;
        this.previewFiles = [];
        this.previewFile = null;
        this.previewMode = 'empty';
        this.previewContent = '';
        this.previewError = '';
        this.previewTruncated = false;
        this.previewUrl = null;
    }

    public toggleNewFolder() {
        this.showNewFolder = !this.showNewFolder;
        this.newFolderName = '';
    }

    public async toggleCreateMenu() {
        if (!this.canWrite()) return;
        this.showCreateMenu = !this.showCreateMenu;
        await this.service.render();
    }

    public async startNewFolder() {
        this.showCreateMenu = false;
        this.toggleNewFolder();
        await this.service.render();
    }

    public async createFolder() {
        if (this.creatingFolder) return;
        let name = (this.newFolderName || '').trim();
        if (!name) {
            await this.showError('폴더 이름을 입력해 주세요.');
            return;
        }
        this.creatingFolder = true;
        await this.service.render();
        try {
            let endpoint = this.storageMode
                ? '/api/sources/storage/folders/create'
                : '/api/sources/folders/create';
            let payload: any = {
                organization_id: this.selectedOrganizationId,
                name: name
            };
            if (this.storageMode) payload.path = this.currentFolder ? this.currentFolder.id : '';
            else payload.parent_id = this.currentFolder ? this.currentFolder.id : '';
            let result: any = await this.service.request.post(endpoint, payload);
            if (result.code !== 201) {
                await this.showError(result.data && result.data.message ? result.data.message : '폴더를 만들지 못했습니다.');
                return;
            }
            this.showNewFolder = false;
            this.newFolderName = '';
            await this.load();
        } finally {
            this.creatingFolder = false;
            await this.service.render();
        }
    }

    public async chooseFiles(event: any) {
        this.showCreateMenu = false;
        await this.setFiles(Array.from(event.target.files || []));
        event.target.value = '';
    }

    public onDragOver(event: any) {
        event.preventDefault();
        if (this.trashMode) return;
        if (this.isInternalDriveDrag(event)) {
            this.dragActive = false;
            event.dataTransfer.dropEffect = 'none';
            return;
        }
        this.closeContextMenu();
        this.dragActive = true;
    }

    public onDragLeave(event: any) {
        event.preventDefault();
        if (this.isInternalDriveDrag(event)) return;
        this.dragActive = false;
    }

    public async onDrop(event: any) {
        event.preventDefault();
        this.dragActive = false;
        if (this.isInternalDriveDrag(event)) {
            this.removeDriveDragPreview();
            this.draggingDriveItems = [];
            this.dragOverFolderId = null;
            await this.service.render();
            return;
        }
        if (!this.canWrite() || this.trashMode) return;
        await this.setFiles(Array.from(event.dataTransfer.files || []));
    }

    private async setFiles(files: any[]) {
        if (this.storageMode) {
            let allowed = ['.pdf', '.json', '.md'];
            let invalid = files.find((file: any) => {
                let name = String(file && file.name || '').toLowerCase();
                return !allowed.some((extension: string) => name.endsWith(extension));
            });
            if (invalid) {
                await this.showError('PDF, JSON, MD 파일만 업로드할 수 있습니다.');
                return;
            }
        }
        if (this.form.asset_id && files.length > 1) files = files.slice(0, 1);
        this.selectedFiles = files;
        this.uploadProgress = 0;
        await this.service.render();
    }

    public removeFile(index: number) {
        this.selectedFiles.splice(index, 1);
    }

    public prepareVersion(asset: any) {
        this.form = {
            asset_id: asset.id,
            asset_title: asset.title,
            source_group: asset.source_group,
            rights_status: asset.rights_status,
            owner_name: asset.owner_name || ''
        };
        this.selectedFiles = [];
        this.uploadProgress = 0;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    public cancelUpload() {
        this.form = this.emptyForm();
        this.selectedFiles = [];
        this.uploadProgress = 0;
        this.dragActive = false;
    }

    private titleFor(file: any) {
        if (this.form.asset_id) return this.form.asset_title;
        let name = file.name || '';
        let dot = name.lastIndexOf('.');
        return dot > 0 ? name.substring(0, dot) : name;
    }

    public async upload() {
        if (!this.selectedOrganizationId) {
            await this.showError('원천 데이터를 등록할 기관을 선택해 주세요.');
            return;
        }
        if (!this.selectedFiles.length) {
            await this.showError('업로드할 파일을 선택해 주세요.');
            return;
        }

        this.uploading = true;
        this.uploadProgress = 0;
        await this.service.render();
        let completed = 0;
        let extracted = 0;
        let queuedOcr = 0;
        try {
            for (let file of this.selectedFiles) {
                let data = new FormData();
                data.append('file', file);
                data.append('organization_id', this.selectedOrganizationId);
                if (this.storageMode) {
                    data.append('path', this.currentFolder ? this.currentFolder.id : '');
                } else {
                    data.append('folder_id', this.currentFolder ? this.currentFolder.id : '');
                    data.append('asset_id', this.form.asset_id || '');
                    data.append('title', this.titleFor(file));
                    data.append('source_group', this.form.source_group);
                    data.append('rights_status', this.form.rights_status);
                    data.append('owner_name', this.form.owner_name || '');
                }

                let result: any = await this.service.file.upload(
                    this.storageMode
                        ? '/api/sources/storage/upload'
                        : '/api/sources/upload',
                    data,
                    async (percent: number) => {
                        this.uploadProgress = Math.round(
                            ((completed + percent / 100) / this.selectedFiles.length) * 100
                        );
                        await this.service.render();
                    }
                );
                if (!result || result.code !== 201) {
                    await this.showError(result && result.data && result.data.message ? result.data.message : file.name + ' 업로드에 실패했습니다.');
                    return;
                }
                completed += 1;
                if (this.storageMode && result.data && result.data.ocr_job) queuedOcr += 1;
                if (!this.storageMode && result.data.auto_extraction && result.data.auto_extraction.status === 'SUCCEEDED') extracted += 1;
            }
            let message = this.storageMode
                ? completed + '개 파일을 현재 폴더에 저장했습니다.'
                    + (queuedOcr ? ' PDF ' + queuedOcr + '개는 OCR 대기열에 등록했습니다.' : '')
                : completed + '개 파일을 저장했고, ' + extracted + '개 파일의 텍스트 추출을 완료했습니다.';
            await this.service.modal.show({
                title: '업로드 완료',
                message: message,
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
            this.cancelUpload();
            await this.load();
        } finally {
            this.uploading = false;
            await this.service.render();
        }
    }

    public groupLabel(value: string) {
        let item = this.sourceGroups.find((group: any) => group.value === value);
        return item ? item.label : value;
    }

    public rightsLabel(value: string) {
        let item = this.rightsStatuses.find((status: any) => status.value === value);
        return item ? item.label : value;
    }

    public sizeLabel(value: number) {
        if (!value) return '0 B';
        if (value >= 1024 * 1024) return (value / (1024 * 1024)).toFixed(1) + ' MB';
        if (value >= 1024) return (value / 1024).toFixed(1) + ' KB';
        return value + ' B';
    }

    public extractionLabel(version: any) {
        let job = version && version.latest_extraction;
        if (!job) return version && version.metadata.extractable ? '추출 대기' : '추출기 준비 필요';
        if (job.status === 'SUCCEEDED') return '추출 완료';
        if (job.status === 'FAILED') return '추출 실패';
        if (job.status === 'RUNNING') return '추출 중';
        return '추출 대기';
    }

    public formatDate(value: any) {
        return formatKstDate(value, '—');
    }

    public formatDateTime(value: any) {
        return formatKstDateTime(value, '—');
    }
}

export default PageAuthoringSourcesComponent;